<template>
	<div class="page">
		<top-header></top-header>
		<div class="cont-box">
			<b-container fluid style="margin-top:5%">
				<b-row >					
					<b-col cols="12" class="text-center ">
						<h5 class="text-uppercase text-white"><b>{{zoneinfo.title}}</b></h5>
					</b-col>					
				</b-row>
			</b-container>	
			<!--  diaplay Map  -->
			<b-container fluid>
				<b-row class="my-3">
					<b-col>
						<div class="imgColorpicker">
							<ul>
													
								<li><b-img src="https://nhaihyd.ccms.live/icon/pin-green.png"></b-img><span> CCMS On</span></li>
								<li><b-img src="https://nhaihyd.ccms.live/icon/pin-red.png"></b-img><span> CCMS Off</span></li>
								<li><b-img src="https://nhaihyd.ccms.live/icon/pin-blue.png"></b-img><span> Signal Loss</span></li>
								<li><b-img src="https://nhaihyd.ccms.live/icon/pin-white.png"></b-img><span> Power Cut</span></li>
								<!-- <li><b-img src="https://nhaihyd.ccms.live/icon/pin-black.png"></b-img><span> CCMS Complaints</span></li> -->
								
								<li ><b-button @click="focusMyLocation" size="sm"  class="myselflocation"><b-img src="https://nhaihyd.ccms.live/icon/pin-myself.png" ></b-img> <span>My Location</span></b-button></li>
							</ul>
						</div>
						<gmap-map :center="center" :zoom="12" class="googlemap">
							<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWindowOpen" @closeclick="infoWindowOpen=false" ref="infoWindow"></gmap-info-window>
							<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :icon="m.icon" 
							
							 :label="{
								text:m.lable,       
								color: '#39FF14',       
								fontSize: '8px',
	fontWeight: 'bold',
	level: 'left'
}"
			:label-origin="{ x: 0, y: 0 }"				
							@click="toogleMarkerInfoWindow(m,index)"></gmap-marker>
						</gmap-map>

						<!--:label="m.lable"  @mouseover="showMarkerTooltip(m, index)"
							@mouseout="hideMarkerTooltip" <gmap-info-window 
						:options="infoOptions" 
						:position="infoWindowPos" 
						:opened="infoWindowOpen" 
						@closeclick="infoWindowOpen=false"
						ref="infoWindow"
						></gmap-info-window>
						<gmap-marker 
						:key="index" 
						v-for="(m, index) in markers" 
						:position="m.position" 
						:clickable="true" 
						:icon="m.icon"
						@mouseover="showMarkerTooltip(m, index)"
						@mouseout="hideMarkerTooltip"
						@click="toogleMarkerInfoWindow(m, index)"
						></gmap-marker>
					</gmap-map> -->


					</b-col>
				</b-row>
			</b-container>
		
			<b-container fluid>
				<b-row class="px-2">
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-primary bg-card-blue">
							<b-row>
								<b-col lg="8" sm="12" md="8" class="text-left ">
									<h6>Total CCMS</h6>
									<b-card-text>
										{{records.length}}
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/street-light.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
					</b-col>
					<b-col class="px-2">

						<b-card class="info-box mb-3 icon-card-primary bg-card-orange">
							<b-row>
								<b-col lg="8" sm="12" md="8" class="text-left ">
									<h6>CCMS Connected</h6>
									<b-card-text>
										{{ device_connected }} <small>Nos</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/street-light-1.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>

						<!-- <b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>CCMS Connected</h6>
							<b-card-text>
								{{ device_connected }} <small>Nos</small>
							</b-card-text>
						</b-card> -->
						
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-primary bg-card-gray">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Signal Loss (CCMS)</h6>
									<b-card-text>
										{{ records.length - device_connected }} <small>Nos</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/street-light-2.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>

						<!-- <b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
							<h6>Temp. Signal Loss (CCMS)</h6>
							<b-card-text>
								{{ records.length - device_connected }} <small>Nos</small>
							</b-card-text>
						</b-card> -->
						
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-primary bg-card-green">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>CCMS ON</h6>
									<b-card-text>
										{{ device_on }} <small>Nos</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/street-light-3.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
							<h6>CCMS ON</h6>
							<b-card-text>
								{{ device_on }} <small>Nos</small>
							</b-card-text>
						</b-card> -->
						
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-danger bg-card-red">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6 style="height: 18px;">CCMS OFF </h6>
									<b-card-text>
										{{ device_connected - device_on }} <small>Nos</small>
										<span>
										<p style="font-size: 11px;padding-top: 4px;margin: 0px;">( Power Cut : {{total_power_cut}} Nos )</p>
									</span>
									</b-card-text>
									
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/lightbulb.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
							<h6>CCMS OFF</h6>
							<b-card-text>
								{{ device_connected - device_on }} <small>Nos</small>
							</b-card-text>
						</b-card> -->
					</b-col>
					<!--<b-col>
						<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Load</h6>
							<b-card-text>
								{{ $root.tofixed(total_load / 1000 , 3) }} <small>KW</small>
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Current Load</h6>
							<b-card-text>
								{{current_load/100000}} <small>KW</small>
							</b-card-text>
						</b-card>
					</b-col>-->
				</b-row>
				<b-row class="px-2">
					<b-col class="px-2" v-if="custom_user == '27'">

						<b-card class="info-box mb-3 icon-card-primary">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Total Lights</h6>
									<b-card-text>
										{{fixed_led}}
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/street-light.svg"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>

						<!-- <b-card img-src="../assets/street-light.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Lights</h6>
							<b-card-text>
								{{fixed_led}}
							</b-card-text>
						</b-card> -->
					</b-col>
					<b-col class="px-2" v-else>
						<b-card class="info-box mb-3 icon-card-primary bg-card-blue">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Total Lights</h6>
									<b-card-text>
										{{total_lights}}
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/idea.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/street-light.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Lights</h6>
							<b-card-text>
								{{total_lights}}
							</b-card-text>
						</b-card> -->
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-primary bg-card-light-on">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Total Light ON</h6>
									<b-card-text>
										{{total_light_on}} <small>({{ $root.tofixed((total_light_on/total_lights)*100, 2) }}%)</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/light.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/light-on.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
							<h6>Total Light ON</h6>
							<b-card-text>
								{{total_light_on}} <small>({{ $root.tofixed((total_light_on/total_lights)*100, 2) }}%)</small>
							</b-card-text>
						</b-card> -->
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-danger bg-card-red">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Total Light OFF</h6>
									<b-card-text>
										{{total_light_off}} <small>({{ $root.tofixed((total_light_off/total_lights)*100, 2) }}%)</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/flash-off.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/light-off.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
							<h6>Total Light OFF</h6>
							<b-card-text>
								{{total_light_off}} <small>({{ $root.tofixed((total_light_off/total_lights)*100, 2) }}%)</small>
							</b-card-text>
						</b-card> -->
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-primary bg-card-gray">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Signal Loss (Light)</h6>
									<b-card-text>
										{{total_signal_loss+total_pending}} <small>({{ $root.tofixed(((total_signal_loss+total_pending)/total_lights)*100, 2) }}%)</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/light-load.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
							<h6>Temp. Signal Loss (Light)</h6>
							<b-card-text>
								{{total_signal_loss+total_pending}} <small>({{ $root.tofixed(((total_signal_loss+total_pending)/total_lights)*100, 2) }}%)</small>
							</b-card-text>
						</b-card> -->
					</b-col>
					<b-col class="px-2">
						<b-card class="info-box mb-3 icon-card-primary bg-card-light-consumption">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Total Consumption</h6>
									<b-card-text>
										{{total_kwh}} <small>KWH</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/light-load-1.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						<!-- <b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Consumption</h6>
							<b-card-text>
								{{total_kwh}} <small>KWH</small>
							</b-card-text>
						</b-card> -->
					</b-col>
				</b-row>
				<b-row class="px-2 justify-content-center">
					
					<!--<b-col class="px-2">
						<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Load</h6>
							<b-card-text>
								{{ $root.tofixed(total_load / 1000 , 3) }} <small>KW</small>
							</b-card-text>
						</b-card>
					</b-col>-->
					<b-col class="px-2" v-if="custom_user == '27'" style="max-width:20%">
						<b-card img-alt="Card image" img-left class="info-box mb-3">
							<h6 class="text-center h-15 mb-0">Total Load ({{ $root.tofixed(fixed_load / 1000 , 3) }} <small>KW</small>)</h6>
							<p class="text-center my-0 py-0">({{fixed_led}} Lights)</p>
							<hr class="my-1" aria-orientation="horizontal">
							<b-row>
								<b-col>
									<h6 class="text-left h-20 mb-0">CCMS Load</h6>
									<b-card-text class="text-left my-1">
										{{$root.tofixed((current_load*1000 + signal_loss_load)/1000, 1)}} <small>KW</small><br>
									</b-card-text>
								</b-col>
								<b-col>
									<h6 class="h-20 mb-0">Direct Load</h6>
									<b-card-text class="text-right my-1">
										{{ $root.tofixed(direct_load/1000, 1) }} <small>KW</small><br>
									</b-card-text>
								</b-col>
							</b-row>
						</b-card>
					</b-col>		
					
					<b-col class="px-2" v-else  style="max-width:20%">
						<b-card class="info-box mb-3 icon-card-primary bg-card-light-load">
							<b-row>
								<b-col lg="8" sm="8" md="8" class="text-left ">
									<h6>Total Load</h6>
									<b-card-text>
										{{ $root.tofixed(total_load / 1000 , 2) }} <small>KW</small>
									</b-card-text>
								</b-col>
								<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
									<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/light-load-2.png"  ></b-img></div>
								</b-col>
							</b-row>							
						</b-card>
						
					</b-col>

									
						
						<b-col class="px-2"  style="max-width:20%">
							<b-card class="info-box mb-3 icon-card-primary bg-card-light-current-load">
								<b-row>
									<b-col lg="8" sm="8" md="8" class="text-left ">
										<h6>Current Load</h6>
										<b-card-text>
											{{$root.tofixed(current_load, 2)}} <small>KW</small> <small>({{ $root.tofixed((current_load/(total_load / 1000))*100, 2) }}%)</small>
										</b-card-text>
									</b-col>
									<b-col lg="4" sm="4" md="8" class="d-flex align-items-center" >
										<div class="icon mb-0 mb-md-2 mb-xl-0 mr-0"><b-img src="../assets/icon/light-load-3.png"  ></b-img></div>
									</b-col>
								</b-row>							
							</b-card>
							<!-- <b-card img-src="../assets/green-energy.svg" img-alt="Card image" img-left class="info-box mb-3">
								<h6>Current Load</h6>
								<b-card-text>
									{{$root.tofixed(current_load, 2)}} <small>KW</small>
								</b-card-text>
							</b-card> -->
						</b-col>


					
				</b-row>
				<b-row class="panel-schedule-info m-0">
					<b-col lg="4" md="4" sm="12">
						<!-- <h6 class="m-0"><b><i>SCHEDULE TIMING:&nbsp;&nbsp;</i> <span style="font-size:13px; padding-left:10px;">ON TIME:</span> <b-badge pill variant="warning">{{zoneinfo.on_time}}</b-badge> <span style="font-size:13px; padding-left:10px;">OFF TIME:</span> <b-badge pill variant="warning">{{zoneinfo.off_time}}</b-badge></b></h6> -->

						<b-row>
							<b-col class="font12 text-left"><b><i>SCHEDULE TIMING:&nbsp;&nbsp;</i></b></b-col>
							<b-col class="font12 text-left"><b>ON Time</b></b-col>
							<b-col class="font12 text-left"><b>OFF Time</b></b-col>
						</b-row>
						<b-row :key="index" v-for="(dg, index) in deviceGroup" class="font-small"> 
							<b-col class="font12 text-left">{{ dg.name }}</b-col>
							<b-col  class="font11 text-left">{{ dg.on_time }}</b-col>
							<b-col  class="font11 text-left">{{ dg.off_time}}</b-col>
						</b-row>

					</b-col>
					<b-col lg="1" md="1" sm="12">
						<b-img src="../assets/icon/light.png"   class="fluid"></b-img> 
					</b-col>
					<b-col lg="47" md="7" sm="12" >
 						<h6 class="m-0 text-right "><b>   
								<b-row>

									<!-- self.total_overload_percent=0;
									self.total_underload_percent=0 -->
									<!-- {{ total_overload_percent }}  -->
									<b-col v-if="total_overload_percent>overload_variable" @click="showfilteroverload" style="font-size:13px; " class="pt-4 mr-1 underloadDang text-center">OVERLOAD: <b-badge pill variant="warning">{{total_overload}}</b-badge><p>{{ total_overload_percent }} % (<small>ON: {{total_light_on_overload  }} | OFF: {{ total_light_off_overload }}</small>)</p></b-col>

									<b-col v-if="total_overload_percent<=overload_variable" @click="showfilteroverload" style="font-size:13px; " class="pt-4  mr-1  underloadwor text-center">OVERLOAD: <b-badge pill variant="danger">{{total_overload}}</b-badge><p>{{ total_overload_percent }} % (<small>ON: {{total_light_on_overload  }} | OFF: {{ total_light_off_overload }}</small>)</p></b-col>

									
									<b-col  v-if="total_underload_percent>underload_variable" @click="showfilterunderload" style="font-size:13px; " class="pt-4 underloadDang text-center" lg="3" md="3" sm="3"  >UNDERLOAD: <b-badge pill variant="warning">{{total_underload}}</b-badge> <p>{{ total_underload_percent }} % (<small>ON: {{total_light_on_underload  }} | OFF: {{ total_light_off_underload }}</small>)</p></b-col>
									<b-col  v-if="total_underload_percent<=underload_variable"  @click="showfilterunderload" style="font-size:13px; " class="pt-4 underloadwor text-center" lg="3" md="3" sm="3">UNDERLOAD: <b-badge pill variant="danger">{{total_underload}}</b-badge> <p>{{total_underload_percent }} % (<small>ON: {{total_light_on_underload  }} | OFF: {{ total_light_off_underload }}</small>)</p></b-col>

									<b-col style="font-size:13px; " class="pt-4">POWER CUT: <b-badge pill variant="warning">{{total_power_cut}}</b-badge> </b-col>
									<b-col style="font-size:13px; " class="pt-4">MANUAL: <b-badge pill variant="primary">{{total_manual}}</b-badge></b-col>


									


									<b-col style="font-size:13px; " class="pt-4">COMPLAINTS:<b-badge pill variant="danger">{{total_complaints}}</b-badge></b-col>
								</b-row>
						
						</b></h6>
					</b-col>
				</b-row>
		
			</b-container>	
				
			<b-container fluid class="pb-4 ">		
				<div class="panel-record mt-4 mb-4">
					<!-- <b-row class="loadPanel">
						<b-col  offset-md="7">
							<b-form inline>
								<b-link @click="showUnderload" class="mr-3">Underload At 8PM </b-link>
							<b-form-group>                
							
							<b-form-datepicker
								v-model="datefrom"
								class="mr-sm-2"
								size="sm"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
							></b-form-datepicker>
							</b-form-group>
							</b-form>
						</b-col>
						<b-col lg="2" md="2" sm="2" >
							<b-button variant="dark" size="sm"  class="mr-2" v-if="$root.chkperm('page_devices','add')" @click="showAddModal()"> Add CCMS </b-button>
						<b-button variant="dark" size="sm" class="" v-if="$root.chkperm('page_devices','export')"  @click="downloadcsv()">Export</b-button>

						</b-col>
					</b-row> -->
					<div style="position: relative;float: right;border-bottom: 1px solid #c6c6c6;padding: 5px;">
						  <!--<span class="mr-4"> <b-link @click="showUnderload">Underload At 8PM</b-link> 
						
						</span> -->
						<b-button variant="dark" size="sm"  class="mr-2" v-if="$root.chkperm('page_devices','add')" @click="showAddModal()"> Add CCMS </b-button>
						<b-button variant="dark" size="sm" class="" v-if="$root.chkperm('page_devices','export')"  @click="downloadcsv()">Export</b-button>
						<span v-if="$root.chkperm('page_devices','control')">
						<b-button variant="dark" size="sm"  class="mr-2 ml-2" v-if="$root.chkperm('page_devices','replace')" @click="lightonoffAll('ON')"> Emergency ON </b-button>
						<b-button variant="dark" size="sm" class="" v-if="$root.chkperm('page_devices','export')"  @click="lightonoffAll('OFF')">Emergency OFF</b-button>
						</span>

			
					</div> 
					<b-tabs content-class="mt-3" align="center" active-nav-item-class="font-weight-bold text-danger" v-model="tabIndex">
						<b-tab title="LIVE RECORDS" active>
								<b-row class="">
									<b-col lg="2">
										<span class="mr-2">Show</span>
										<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
										</b-form-select>
										<span class="ml-2">entries</span>
									</b-col>
									<b-col lg="7" class="text-center space-between">
										<span class="mr-2">Filters</span>
										<b-form-select v-model="selectedfilter" :options="filteroptions" size="sm" class="w-20" @change="onFilterChange()">
										</b-form-select>
										<span class="ml-3 mr-2">Wards</span>
										<VSelect v-model="wardfilter" :options="wardfilterlist" :searchable="true" defaultTitle="All Wards" size="sm" class=" w-20 custom-select custom-select-sm ml-2" @input="onFilterChange()"></VSelect>
										
										<!-- <span class="ml-3 mr-2">Network</span>
										<b-form-select v-model="networkfilter" size="sm" class=" w-10" @change="onFilterChange()">
											<b-form-select-option value="0">All</b-form-select-option>
											<b-form-select-option value="2G">2G</b-form-select-option>
											<b-form-select-option value="4G">4G</b-form-select-option>
										</b-form-select>  -->
										<!-- <span class="ml-3 mr-2">Phase</span>
										<b-form-select v-model="phasefilter" size="sm" class=" w-10" @change="onFilterChange()">
											<b-form-select-option value="0">All</b-form-select-option>
											<b-form-select-option value="1">1st</b-form-select-option>
											<b-form-select-option value="2">2nd</b-form-select-option>
										</b-form-select>
										<span class="ml-3 mr-2">Vendor</span>
										<b-form-select v-model="vendorfilter" size="sm" class=" w-10" @change="onFilterChange()">
											<b-form-select-option value="0">All</b-form-select-option>
											<b-form-select-option value="1">Matrix</b-form-select-option>
											<b-form-select-option value="2">Horizon</b-form-select-option>
										</b-form-select> -->
										<!--<span class="ml-3 mr-2">Meter</span>
										<b-form-select v-model="meterfilter" size="sm" class=" w-15" @change="selectedfilter='ALL'; networkfilter=0; onFilterChange()">
											<b-form-select-option value="0">All</b-form-select-option>
											<b-form-select-option value="1">Phase 1</b-form-select-option>
											<b-form-select-option value="2">Phase 2</b-form-select-option>
										</b-form-select>-->
										<!--<span class="ml-4 mr-2">Power Filter</span>
										<b-form-select v-model="powerfilter" :options="powerOptions" size="sm" class="w-25" @change="onFilterDevices()">
										</b-form-select>-->
									</b-col>
									<b-col lg="3">
										<b-form-group label="Filter" label-cols-sm="3" label-align-sm="left" label-size="sm" label-for="filterInput" class="mb-0">
											<b-input-group size="sm">
												<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search" class="custom-input">
												</b-form-input>
												<b-input-group-append>
													<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row class="pt-3">
									<b-col lg="12">

										
										<!-- style="min-height: 400px;"  caption-top  hover  borderless="borderless" stickyColumn="scrolled" stacked="md" :style="tableHeight"-->
										<b-table  :style="tableHeight" show-empty  small sticky-header="true" responsive outlined  head-variant="dark"   caption-top hover borderless="borderless" stickyColumn="scrolled" id="my-table-live"  :items="filteredrecords" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" class="scrollH d-flex">
											
											
											<template v-slot:head(feeder_pillar_no)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
												</span>           
											</template>

											<template v-slot:head(mobile_no)="data">                     
												{{ data.label}}  <b-link   @click="mobilenodownload()"> <img src="../assets/download.svg"  style="max-width:15px; max-height:15px;"></b-link>       
												          
											</template>

											<template v-slot:head(phase)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Installation Phase'" >{{ data.label}}           
												</span>           
											</template>
											<template v-slot:head(no_of_fittings)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Number of Lights.'" >{{ data.label}}           
												</span>           
											</template>

											<template v-slot:head(meter_phase_type)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Phase Type'" >{{ data.label}}           
												</span>           
											</template>
											<template v-slot:head(modem_type)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Modem type'" >{{ data.label}}           
												</span>           
											</template> 
											<template v-slot:head(overload)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Over Load'" >{{ data.label}}           
												</span>           
											</template> 
											<template v-slot:head(underload)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Underload'" >{{ data.label}}           
												</span>           
											</template>
											<template v-slot:head(mode)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Green:Power mode | Red:Battery Mode'" >{{ data.label}}           
												</span>           
											</template>
											<!-- <template v-slot:head(ulb)="data">                     
												<span :title='data.tooltip' v-b-popover.hover.top="'Urban Local Body'" >{{ data.label}}           
												</span>           
											</template> -->

											<template v-slot:cell(location)="row">
												<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
												<b-popover
													:target="`l-${row.item.id}`"
													title="Location"
													triggers="hover focus">
													{{row.item.location}}													
												</b-popover>
											</template>
											<template v-slot:cell(ward_id)="row">
												<span :id="'wl-'+row.item.id" pill variant="success" v-if="row.value!=0">{{row.value.areacode}}</span>
												<span v-else pill variant="success" >No Ward</span>
												<b-popover
													:target="`wl-${row.item.id}`"
													title="Ward"
													triggers="hover focus">
													{{row.value.title}}													
												</b-popover>
											</template>
											
											<template v-slot:cell(no_of_fittings)="row">
												<b-badge :id="'F-'+row.item.id" pill variant="success">{{row.item.no_of_fittings}}</b-badge>
												<b-popover
													:target="`F-${row.item.id}`"
													title="Total Fittings!"
													triggers="hover focus">
													<div v-for="value in watts" v-bind:key="value">
														<b-row v-if="row.item.led_fittings['w'+value] > 0">
															<b-col><b-badge pill variant="light" class="pb-1">{{value}} w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.led_fittings['w'+value]}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{value * row.item.led_fittings['w'+value]}} w</b-badge></b-col>
														</b-row>
													</div>													
												</b-popover> 
											</template>
											<template v-slot:cell(geo_loc)="row"> 
												<!-- <span>{{row.item.location_lat}}</span><br><span>{{row.item.location_lng}}</span> -->
												<a x-small :href="maplink+my_latitude+','+my_longitude+'/'+row.item.location_lat+','+row.item.location_lng" class="text-decoration-none" target="_blank">{{row.item.location_lat}}/{{ row.item.location_lng }}</a>
												
											</template>
											<template v-slot:cell(maintenance)="row">
												<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
												<b-badge pill variant="secondary" v-else>NO</b-badge>
											</template>
											<template v-slot:cell(door_status)="row">
												<b-badge pill size="sm" variant="danger" v-if="row.value == 1">OPENED</b-badge>
												<b-badge pill size="sm" variant="success" v-else>CLOSED</b-badge>
											</template>
											<template v-slot:cell(mcb_status)="row">

												<b-list-group style="flex-direction:row;">
													<b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
														<span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> R
													</b-list-group-item>

													<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
														
														<span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> Y
													</b-list-group-item>

													<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
														<span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> B
													</b-list-group-item>
												</b-list-group>
												
											</template>
											<template v-slot:cell(overload)="row">
												<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
												<!-- <b-badge pill variant="danger" v-else> 0 %</b-badge> -->
												<!--<b-badge pill variant="warning" v-else-if="(row.item.output_status == 1 && row.value == 0 )">{{row.value}} %</b-badge>-->
												<!--<b-badge pill variant="success" v-else>{{row.value}} %</b-badge>-->
											</template>
											<template v-slot:cell(underload)="row">
												<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
												<!-- <b-badge pill variant="primary" v-else >0%</b-badge> -->
												
											</template>
											<template v-slot:cell(supply)="row">
												<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
												<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">

												<!-- <img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
												<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;"> -->
											</template>
											<template v-slot:cell(output_status)="row">
												<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
												<b-badge pill variant="danger" v-else>OFF</b-badge>
											</template>
											<template v-slot:cell(sys_meter_no)="row">
												<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
											</template>
											<!-- <template v-slot:cell(meter_phase_type)="row">
												
												<div  style="display:flex; flex-direction:column; row-gap:2px;">
													<img src="../assets/meter-ok.svg" v-if="row.item.amp_r > 0" style="max-width:14px; max-height:14px;" class="my-0">
													<img src="../assets/meter-error.svg" v-else style="max-width:14px; max-height:14px;" >

													<img src="../assets/meter-ok.svg" v-if="row.item.amp_y > 0" style="max-width:14px; max-height:14px;" class="my-0">
													<img src="../assets/meter-error.svg"  v-else   style="max-width:14px; max-height:14px;" >
													
													<img src="../assets/meter-ok.svg" v-if="row.item.amp_b > 0"  style="max-width:14px; max-height:14px;" class="my-0">
													<img src="../assets/meter-error.svg"  v-else style="max-width:14px; max-height:14px;" >
													
												</div>
												
											</template> -->
											<template v-slot:cell(mode)="row">
												<img src="../assets/meter-ok.svg"  v-if="row.value == 1" style="max-width:14px; max-height:14px;">
												<img src="../assets/meter-error.svg" v-else style="max-width:14px; max-height:14px;">
											</template>
											<template v-slot:cell(feeder_pillar_no)="row">
												<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
											</template>
											<template v-slot:cell(ploe_no_start)="row">
												<p>{{row.item.ploe_no_start+' - '+row.item.ploe_no_end}}</p>
											</template>
											<template v-slot:cell(connection_status)="row">
												<span style="font-size: 10px;">{{row.item.last_event}}</span>
												<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
												<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
												<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
												<b-badge pill variant="success" v-else>CONNECTED</b-badge>
											</template>
											<template v-slot:cell(actions)="row">

												
												<b-button pill variant="primary" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','replace')" @click="showReplaceModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="gear-fill" font-scale="1" ></b-icon></b-button>
												<b-button pill variant="info" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','view')" @click="showViewModal(row.item, $event.target)" size="sm"><b-icon icon="search" font-scale="1" ></b-icon></b-button>
												<b-button pill variant="primary" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','edit')" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="pencil" font-scale="1" ></b-icon></b-button>
												<b-button pill variant="danger" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','delete')" @click="showDeleteModal(row.item)" size="sm"><b-icon icon="trash" font-scale="1" ></b-icon></b-button>

												<!-- <b-button pill variant="success" class="mr-1" size="sm" v-if="$root.chkperm('page_devices','control')" @click="sendCommand('ON', row.item.imei_no)" ><b-icon icon="power"></b-icon> ON</b-button>
												<b-button pill variant="danger" class="mr-1" size="sm" v-if="$root.chkperm('page_devices','control')" @click="sendCommand('OFF', row.item.imei_no)" ><b-icon icon="power"></b-icon> OFF</b-button> -->

												
												
												<span v-if="row.item.group_id!=6">
													<p v-if="$root.chkperm('page_devices','control') && row.item.connection_status == 1" class="p-1">												
															<span v-if="row.item.output_status==1">
																<!-- ON: {{row.item.output_status}} -->
																<toggle-button  :value="true" :name="row.item.imei_no" @change="onChangeEventHandler(row.item.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="25" />
															</span>
															<span v-else >
																<!-- off:{{row.item.output_status}} -->
																<toggle-button :value="false" :name="row.item.imei_no" @change="onChangeEventHandler(row.item.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="20" />

															</span>
													</p>
												</span>
												<span v-else>
													<!-- <p v-if="$root.chkperm('page_devices','control')" class="p-1">	
														 =========================R Y B PHASE ON/OFF================================	
																		
														<toggle-button  :value="row.item.amp_r>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'R',$event)" :sync="true" :labels="{checked: 'R Light ON', unchecked: 'R Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />		
														
														<toggle-button  :value="row.item.amp_y>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'Y',$event)" :sync="true" :labels="{checked: 'Y Light ON', unchecked: 'Y Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />

														<toggle-button  :value="row.item.amp_b>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'B',$event)" :sync="true" :labels="{checked: 'B Light ON', unchecked: 'B Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />
															
													</p>  -->
													<p v-if="$root.chkperm('page_devices','control') && row.item.connection_status == 1" class="p-1">												
															<span v-if="row.item.output_status==1">
																<!-- ON: {{row.item.output_status}} -->
																<toggle-button  :value="true" :name="row.item.imei_no" @change="onChangeEventHandler(row.item.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="25" />
															</span>
															<span v-else >
																<!-- off:{{row.item.output_status}} -->
																<toggle-button :value="false" :name="row.item.imei_no" @change="onChangeEventHandler(row.item.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="20" />

															</span>
													</p>

												</span>
											</template>
										</b-table>
									</b-col>
								</b-row>
								<b-row class="px-1">
									<b-col lg="6">
										<span class="mr-2">Showing {{currentPage}} to {{(perPage>filteredrecords.length)?filteredrecords.length:perPage}} of {{filteredrecords.length}} entries</span>
									</b-col>
									<b-col lg="3" offset-md="3">
										<b-pagination v-model="currentPage" pills :total-rows="filteredrecords.length" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
									</b-col>
								</b-row>
						</b-tab>
						<!-- <b-tab style="display:none" :title="'FAULTY LIGHTS ('+fault_records.length+')'" v-if="$root.chkperm('page_devices','light_fault_list')">
							<b-table show-empty sticky-header small hover outlined borderless="borderless" id="my-table" stacked="md" :items="fault_records" :fields="fields_fault">
								<template v-slot:cell(location)="row">
									<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
									<b-popover
										:target="`l-${row.item.id}`"
										title="Location"
										triggers="hover focus">
										{{row.item.location}}													
									</b-popover>
								</template>

								<template v-slot:cell(ward_id)="row">
									<span :id="'wl-'+row.item.id" pill variant="success"  v-if="row.value!=0">{{row.value.areacode}}</span>
									<span v-else pill variant="success" >No Ward</span>
									<b-popover
										:target="`wl-${row.item.id}`"
										title="Location"
										triggers="hover focus">
										{{row.value.title}}													
									</b-popover>
								</template>

								<template v-slot:cell(maintenance)="row">
									<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
									<b-badge pill variant="secondary" v-else>NO</b-badge>
								</template>
								<template v-slot:cell(door_status)="row">
									<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
									<b-badge pill variant="success" v-else>CLOSED</b-badge>
								</template>
								
								<template v-slot:cell(mcb_status)="row">
									<b-list-group style="flex-direction:row;">
										<b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
											<span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> R
										</b-list-group-item>

										<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
											
											<span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> Y
										</b-list-group-item>

										<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
											<span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> B
										</b-list-group-item>
									</b-list-group>
								</template>

								
								<template v-slot:cell(overload)="row">
									<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
									<b-badge pill variant="danger" v-else> 0 %</b-badge>
									
								</template>
								
								<template v-slot:cell(underload)="row">
									<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
									<b-badge pill variant="primary" v-else>0 %</b-badge>
								</template>
								<template v-slot:cell(supply)="row">
									<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
									<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
								</template>
								<template v-slot:cell(output_status)="row">
									<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
									<b-badge pill variant="danger" v-else>OFF</b-badge>
								</template>
								<template v-slot:cell(sys_meter_no)="row">
									<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
									<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
								</template>
								<template v-slot:cell(mode)="row">									
									<img src="../assets/meter-ok.svg" v-if="row.value == 1"  style="max-width:14px; max-height:14px;">
									<img src="../assets/meter-error.svg"  v-else style="max-width:14px; max-height:14px;">
								</template>
								<template v-slot:cell(feeder_pillar_no)="row">
									<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
								</template>
								<template v-slot:cell(ploe_no_start)="row">
									<p>{{row.item.ploe_no_start+' - '+row.item.ploe_no_end}}</p>
								</template>


								
								<template v-slot:cell(connection_status)="row">
									<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
									<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
									<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
									<b-badge pill variant="success" v-else>CONNECTED</b-badge>
								</template>
								
							</b-table>
						</b-tab> -->
						<b-tab style="display:none" title="UNDERLOAD" class="undelodpanel" :title-item-class="underloadMode">
							 <underload-report :tableHeight="tableHeight" ></underload-report>			
						</b-tab>
					</b-tabs>
					<b-row>
						<b-col>
							
						</b-col>
					</b-row>

				
					<b-container fluid style="display:none">
						<b-row class="my-3">
							<b-col md="12">
								<line-chart ref="livechart"/>
							</b-col>
						</b-row>
					</b-container>
					<!-- <b-row class="my-3">
						<b-col> 
							<div class="float-left">
								<img src="../assets/flag-green.png" style="width: 20px; max-height:28px;"/>
								<span class="pl-2 text-sm"><b>DEVICE ON</b></span>
							</div>
							<div class="float-left ml-5">
								<img src="../assets/flag-red.png" style="width: 20px; max-height:28px;"/>
								<span class="pl-2 text-sm"><b>DEVICE OFF</b></span>
							</div>
							<div class="float-left ml-5">
								<img src="../assets/flag-blue.png" style="width: 20px; max-height:28px;"/>
								<span class="pl-2 text-sm"><b>TEMPORARY SIGNAL LOSS</b></span>
							</div>
						</b-col>
						<b-col cols="6">
							<span class="float-right text-sm pt-2"><b>LAST SYNC TIME: {{$moment(last_sync_time).format('DD-MM-YYYY HH:mm')}}</b></span>
							
						</b-col>
					</b-row> -->
				
					<b-modal id="view-model" title="View DCU" size="lg" ok-only @show="viewdata" @hide="setMaintenance">
						<b-container fluid>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">IMEI :</b-col>
								<b-col cols="8">{{selectedItem.imei_no}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Zone :</b-col>
								<b-col cols="8">{{selectedItem.ulb_id}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Feeder Pillor No :</b-col>
								<b-col cols="8">{{selectedItem.feeder_pillar_no}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Meter No:</b-col>
								<b-col cols="8" class="text-wrap text-break">{{selectedItem.sys_meter_no}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Installation Date:</b-col>
								<b-col cols="8" class="text-wrap text-break">{{$moment(selectedItem.insert_time).format('DD-MM-YYYY')}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">RTC (Data Stamp):</b-col>
								<b-col cols="8" class="text-wrap text-break">{{selectedItem.data_stamp}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Data :</b-col>
								<b-col cols="8" class="text-wrap text-break">{{selectedItem.data}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Data Length:</b-col>
								<b-col cols="8" class="text-wrap text-break">{{selectedItem.datalength}}</b-col>
							</b-row>
							<b-row class="mb-1r">
								<b-col cols="4" class="text-right">Time :</b-col>
								<b-col cols="8" class="text-wrap text-break">{{selectedItem.update_time}}</b-col>
							</b-row>
						</b-container>
						<template v-slot:modal-footer="{ ok, close }">
							<!--<div v-if="$root.chkperm('page_devices','maintenance')">
								<b-button size="sm" variant="warning" v-if="selectedItem.maintenance == 0" @click="hide('maintenance_on')">Maintenance ON</b-button>
								<b-button size="sm" variant="warning" v-else @click="hide('maintenance_off')">Maintenance OFF</b-button>
							</div>-->
							<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
							<b-button size="sm" variant="success" @click="ok()">Ok</b-button>
						</template>
					</b-modal>

					<b-modal id="replace-model" title="Replace Panel" size="lg" ok-only @hidden="resetSelectedItem" @ok="onReplaceDevice">
						<b-container fluid>
							<b-row class="mb-1">
								<b-col>
									<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
									<b-form-group label="FP No" label-for="fp-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="fp-input" v-model="replaceItem.feeder_pillar_no" disabled></b-form-input>
									</b-form-group>
									<b-form-group label="IMEI No" label-for="imei-input" label-cols="0" label-size="sm" label-align-sm="left" invalid-feedback="Imei is required">
										<b-form-input id="imei-input" v-model="replaceItem.replace_imei_no" disabled></b-form-input>
									</b-form-group>
									<b-form-group label="Meter No" label-for="ccms-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="ccms-input" v-model="replaceItem.replace_meter_no" disabled></b-form-input>
									</b-form-group>
									<b-form-group label="Mobile No" label-for="ccms-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="mobile-input" v-model="replaceItem.mobile_no" disabled></b-form-input>
									</b-form-group>
								</b-col>
								<b-col>
									<b-alert show variant="secondary" class="header-title">Replace Information</b-alert>
									<b-form-group label="New FP No" label-for="fp-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="location-input" v-model="replaceItem.new_fp_no" placeholder="New Feeder Pillar no." disabled></b-form-input>
									</b-form-group>
									<b-form-group label="New IMEI No" label-for="fp-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="location-input" v-model="replaceItem.new_imei_no" placeholder="New Imei no."></b-form-input>
									</b-form-group>
									<b-form-group label="New Meter" label-for="ward-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="location-input" v-model="replaceItem.new_meter_no" placeholder="New Meter no."></b-form-input>
									</b-form-group>
									<b-form-group label="Replace Date" label-for="ward-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-datepicker id="ward-input" v-model="replaceItem.replace_time" :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" required></b-form-datepicker>
									</b-form-group>
									<b-form-group label="Comment" label-for="ward-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-textarea v-model="replaceItem.comment" placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
						</b-container>
						<form ref="form" @submit.stop.prevent="handleSubmit">
							
						</form>
						<template v-slot:modal-footer="{ ok, close }">
							<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
							<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
						</template>
					</b-modal>
				
					<b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit CCMS':'Add CCMS '" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
						<b-container fluid>
							<b-row class="mb-1">
								<b-col>
									<div class="panel-new">
									<h4>Device Information</h4>
									<b-form-group label-for="imei-input" label-cols="0" label-size="sm" label-align-sm="left" invalid-feedback="Imei is required" inline="true">
										<label>Imei</label>
										<b-form-input id="imei-input" v-model="selectedItem.imei_no" :disabled="selectedItem.id > 0" required></b-form-input>
									</b-form-group>
									<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" :disabled="selectedItem.id > 0" required></b-form-input>
									</b-form-group>
									<b-form-group label="Pole No" label-for="fp-ploe_no" label-cols="0" label-size="sm" label-align-sm="left" >
										<div class="d-flex">
										<b-form-input id="fp-ploe_no" v-model="selectedItem.ploe_no_start"  required style="width:40%;"></b-form-input> <span style="margin: 5px 10px;">To </span>
										<b-form-input id="fp-ploe_no_end" v-model="selectedItem.ploe_no_end"  required style="width:40%;"></b-form-input> 
									</div>
										

									</b-form-group>
									<b-form-group label="Device Type" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.device_type" disabled>
											<b-form-select-option value="CCMS">CCMS</b-form-select-option>
											<b-form-select-option value="DCU">DCU</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Meter Type" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.meter_type">
											<b-form-select-option value="1P">3 Phase</b-form-select-option>
											<!-- <b-form-select-option value="1P">1 Phase</b-form-select-option> -->
										</b-form-select>
									</b-form-group>
									<b-form-group label="Modem Type" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.modem_type" disabled>
											<b-form-select-option value="2G">2G</b-form-select-option>
											<b-form-select-option value="4G">4G</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Inst.Phase" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.phase">
											<b-form-select-option value="1">Phase 1</b-form-select-option>
											<b-form-select-option value="2">Phase 2</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Vendor" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.vendor">
											<b-form-select-option value="1">Matrix</b-form-select-option>
											<b-form-select-option value="2">Horizon</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Meter No" label-for="ccms-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="ccms-input" v-model="selectedItem.device_no" :disabled="selectedItem.id > 0" required></b-form-input>
									</b-form-group>
									<b-form-group label="Mobile No" label-for="ccms-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
									</b-form-group>
									<b-form-group label="Consumer No" label-for="consumer-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="consumer-input" v-model="selectedItem.consumer_no" required></b-form-input>
									</b-form-group>
								</div>
								</b-col>
								<b-col >
									<div class="panel-new panel-new-2">
									<h4>Location Information</h4>
									<b-form-group label="State" label-for="fp-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.ulb_id=0" required></b-form-select>
									</b-form-group>
									<b-form-group label="ULB" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.ulb_id">
											<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
											<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Ward" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.ward_id">
											<b-form-select-option value="0">--- No Ward ---</b-form-select-option>
											<b-form-select-option v-for="item in filterWards()" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Zones" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.zone_id">
											<b-form-select-option value="0">--- No Zone ---</b-form-select-option>
											<b-form-select-option v-for="item in filterZones()" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Location" label-for="ward-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
									</b-form-group>
									<b-form-group label="Ward No" label-for="ward-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
									</b-form-group>
									<b-form-group label="Previous Load" label-for="prev-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="prevload-input" v-model="selectedItem.previous_load" required></b-form-input>
									</b-form-group>
									<b-form-group label="Total Load" label-for="load-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
									</b-form-group>
									<!--<b-form-group label="Total Connection" v-if="selectedItem.device_type === 'CCMS'" label-for="poles-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="poles-input" v-model="selectedItem.total_connection" required></b-form-input>
									</b-form-group>-->
									<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
									</b-form-group>
									</div>
								</b-col>
								<b-col >
									<div class="panel-new panel-new-3">
										<h4>LED Information</h4>
										<b-row style="justify-content: center;">
											<b-col class="pr-0" cols="5" v-for="item in watts" v-bind:key="item">
												<b-form-group :label="'LED '+item+' W'" label-cols="0" label-size="sm" label-align-sm="left">
													<b-form-input v-model="selectedItem.led_fittings['w'+item]" @change="updateTotalLoad"></b-form-input>
												</b-form-group>
											</b-col>
										</b-row>
									</div>
								</b-col>
								<b-col >
									<div class="panel-new panel-new-4">
										<h4>Map Information</h4>
										<b-form-group label="Latitude" label-for="load-input" label-cols="0" label-size="sm" label-align-sm="left">
											<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
										</b-form-group>
										<b-form-group label="Longitude" label-for="poles-input" label-cols="0" label-size="sm" label-align-sm="left">
											<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
										</b-form-group>
									</div>
									<div class="panel-new panel-new-5">
										<h4>Set Schedule  </h4>										
										<b-form-group label="Supervisor" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
													<b-form-select v-model="selectedItem.supervisor_id">
														<b-form-select-option value="0">--- Select Supervisor ---</b-form-select-option>
														<b-form-select-option v-for="item in supervisorlist" v-bind:key="item.supervisor_id" :value="item.supervisor_id">{{item.username}}</b-form-select-option>
													</b-form-select>
												</b-form-group>


												<b-form-group label="Device Group" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
													<b-form-select v-model="selectedItem.group_id" @change="setonoffTime" id="groupoptionid">
														<b-form-select-option value="0">--- Select Group ---</b-form-select-option>
														<b-form-select-option v-for="(item, index) in device_group" v-bind:key="index" :value="item.group_id">{{item.name}}</b-form-select-option>
													</b-form-select>
												</b-form-group>




												
										<b-row>


												<b-col>
													<b-form-group label="On Time" label-for="sched_ontime" label-cols="0" label-size="sm" label-align-sm="left">
														<b-form-input id="sched_ontime" v-model="selectedItem.on_time" required placeholder="HH:MM"></b-form-input>
													</b-form-group>					
												</b-col>
												<b-col>
													<b-form-group label="Off Time" label-for="sched_offtime" label-cols="0" label-size="sm" label-align-sm="left" >
															<b-form-input id="sched_offtime" v-model="selectedItem.off_time" required placeholder="HH:MM"></b-form-input>
														</b-form-group>
												</b-col>
										</b-row>
										
									
										
									</div>
								</b-col>


							</b-row>
						</b-container>
						<form ref="form" @submit.stop.prevent="handleSubmit">
							
						</form>
						<template v-slot:modal-footer="{ ok, close }">
							<b-button size="md" variant="danger" @click="close()">Cancel</b-button>
							<b-button size="md" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
						</template>
					</b-modal>
				</div>			

			</b-container>
			<!-- triggers="hover":target="popup_fittings_target"-->
			
			<transition name="fade">
				<b-row v-if="loading" class="loading" style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
					<b-spinner label="Busy" variant="light"></b-spinner>
				</b-row>
			</transition>
		</div>
		
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
import underloadReport from "@/components/Underload_report.vue";
import VSelect from "vue-select-picker-bootstrap";
import { ToggleButton } from 'vue-js-toggle-button'

import { Line } from 'vue-chartjs';
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"underload-report": underloadReport,
		"line-chart": Line,
		ToggleButton,
		VSelect
	},
	beforeDestroy(){
		console.log("CLEAR INTERVAL DASHBOARD");
		clearInterval(this.interval);
		window.removeEventListener("scroll", this.onScroll, true)
	},
	sockets: {
        connect() {
			this.is_connected = 'Connected';
			console.log('socket connected');
        },
		commtoser_res(data){
			 data=JSON.parse(data);
			if(data.error==0){
				this.$bvToast.toast(data.message, {
					title: 'Light status',
					toaster: 'b-toaster-bottom-right', 
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				});
			}else{
				this.$bvToast.toast(data.message, {
					title: 'Light status',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'warning',
					solid: true,
					appendToast: true
				});
			}
			//alert(data);
		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		},
		datarecieved(data){
			console.log('ye le data');
			console.log(JSON.stringify(data));
		},

    },
	mounted(){
		var userinfo = this.$session.get('user_info');
		this.custom_user = userinfo.user_id;

		/* Current My Location  */
		this.getLocation();
		

		if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11 && userinfo.role != 14){
			for(var i=this.fields.length-1; i>=0; i--){
				var field = this.fields[i];
				//console.log(i+' '+hidden_fields.indexOf(field.key)+' '+field.key);
				if(this.hidden_fields.indexOf(field.key) > -1){
					this.fields.splice(i,1);
				}
			}
		}
		
		/*if(this.$route.params.ulbareacode != 'up-meerut-meerut'){
			this.fields.splice(13,1);
		}*/
		this.$refs.livechart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' CCMS CONNECTED',
					borderColor: '#000099',
					backgroundColor: '#99d6ff',
					data: [8275, 5025, 6520, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' CCMS ON',
					borderColor: '#009900',
					backgroundColor: '#00ff04',
					data: [7514, 9652, 4578, 3562, 8562, 1457],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' LOAD',
					borderColor: '#f79800',
					backgroundColor: '#ffb642',
					data: [5236, 5025, 2365, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				}
			]},{
			responsive: true
		});
		this.loadulbs();
		this.loadDevicegroup();
		this.loadzones();
		this.loadwards();
		this.initload();
		window.addEventListener("scroll", this.onScroll, true)
	},
	data() {
		var self = this;
		
		return{			
			custom_user: 0,
			check_inschedule: false,
			loading: true, 
			last_sync_time: '',
			interval: '',
			zoneOptions: [],
			deviceGroup: [],
			wards: [],
			wardfilterlist:[],
			wardfilter:'all',
			networkfilter: 0,
			meterfilter: 0,
			powerfilter: -1,
			phasefilter: 0,
			vendorfilter: 0,
			current_led_load: 0,
			hidden_fields: ['imei_no', 'modem_type','location_lat', 'location_lng', 'sys_meter_no', 'meter_phase_type', 'led_fittings','on_time','off_time'],
			//fault_records: [],
			/* watts: [18,20,24,28,32,35,40,45,50,60,70,72,75,80,90,96,100,110,120,130,140,150,160,190,200,250,400], */
			watts: [20,35,45,60,70,90,110,120,140,150,160,180,190,200,250],
			led_fittings: {},
			total_devices: 0,
			zones: [],
			page_title: '',
			selectedUlb: self.$route.params.ulbareacode,
			ulbsUrl: self.$session.get('apiurl')+'nhaihyd/zone-list',
			zonesUrl: self.$session.get('apiurl')+'nhaihyd/zones',
			wardsUrl: self.$session.get('apiurl')+'nhaihyd/ward-record',
			recordUrl: self.$session.get('apiurl')+'nhaihyd/device-ulbs',
			insertUrl: self.$session.get('apiurl')+'nhaihyd/device-insert',
			updateUrl: self.$session.get('apiurl')+'nhaihyd/device-update',
			deleteUrl: self.$session.get('apiurl')+'nhaihyd/device-delete',
			maintenanceUrl: self.$session.get('apiurl')+'nhaihyd/device-maintenance',
			replaceUrl: self.$session.get('apiurl')+'nhaihyd/replacepanel-insert',
			devicedataUrl: self.$session.get('apiurl')+'nhaihyd/device-oridata',
			groupUrl: self.$session.get('apiurl')+'nhaihyd/device-group-list',
			total_kwh: 0,
			device_on: 0,
			device_connected: 0,
			popup_fittings_target: '',
			fixed_load: 0,
			fixed_led: 0,
			total_load: 0,
			current_load: 0,
			off_load: 0,
			signal_loss_load: 0,
			total_pending: 0,
			direct_load: 0,
			total_lights: 0,
			total_light_on: 0,
			total_light_off: 0,
			total_signal_loss: 0,
			filteredrecords: [],
			info_powerfailure:0,

			server_time: '',

			total_power_cut: 0,
			total_overload: 0,
			total_underload:0,
			total_overload_percent:0,
			total_underload_percent:0,
			overload_variable:40,
			underload_variable:30,
			total_manual: 0,
			total_complaints:0,
			total_light_on_overload:0,
			total_light_off_overload:0,
			total_light_on_underload:0,
			total_light_off_underload:0,

			records: [],
			ignorefields: ['id','sno','state_id','zone_id','ulb_id','data_fault','meter_fault','fault_time','amp_r','amp_y','amp_b','kw_r','kw_y','kw_b','insert_time','last_event','connection_status','maintenance','meter_phase_type','data_stamp','datalength','location_lat','location_lng','vendor','previous_load','total_connection','phase','sys_meter_no','device_no','consumer_no','modem_type','device_type','on_time','off_time','supervisor_id','group_id','ploe_no_start','ploe_no_end'],
			
			fields: [
				/* { key: 'data_stamp', label: 'Data Stamp.', sortable: true, class: 'text-left first-col',
					formatter: (value) => {
						return self.$moment(value).format('DD-MM-YYYY HH:mm');
					}
				}, */
				{ key: 'feeder_pillar_no', label: 'F.No.', sortable: true, stickyColumn: true,  class: 'text-center',thStyle:'min-width:85px;' },
				/* { key: 'ploe_no_start', label: 'Pole No.', class: 'text-center',thStyle:'min-width:85px;'}, */
				{ key: 'ward_id', label: 'Ward', sortable: true,  sortDirection: 'desc' ,thStyle:'min-width:90px;',
					formatter: (value) => {
						if(value > 0){
							return self.wards.filter(function (item) {
								return item.id == value;
							})[0];
						}
						else{
							return 0;
						}
					},
				},
				{ key: 'location', label: 'Location',  sortable: true,  class: 'text-left',thStyle:'min-width:140px;',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 15){
								return value.substring(0,15)+"...";
							}
							
						}
						return value;
					},
				},				
				{ key: 'imei_no', label: 'IMEI', sortable: true,  sortDirection: 'desc' },
				{ key: 'mobile_no', label: 'Mobile No', sortable: true,  sortDirection: 'desc' },
				/* { key: 'phase', label: 'PH', sortable: true,  sortDirection: 'desc' }, */
				{ key: 'no_of_fittings', label: 'Fittings', sortable: false,class: 'text-center',sortByFormatted: true, filterByFormatted: true },
				{ key: 'total_load', label: 'Physical Load', sortable: true,  class: 'text-center',thStyle:'min-width:130px;',
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
				{ key: 'total_kw', label: 'Actual Load', class: 'text-center', sortable: true, sortDirection: 'desc',thStyle:'min-width:130px;',
					formatter: (value, key, item) => { 
						if(item.meter_type === '1P'){
							//return (item.kw_r/10000).toFixed(3);
						}
						if(item.output_status == 0){
							//value = 0;
						}
						return parseFloat(value).toFixed(3);
					},
				},
				{ key: 'supply', label: 'Power', class:"text-center", 
					formatter: (value, key, item) => {
						var supply = 'ON';
						if(item.datalength == 59){
							supply = 'OFF';
						}
						if(value < 120){
							supply = 'OFF';
						} 
						return supply;
					},
				},
				{ key: 'door_status', label: 'Door Status', sortable: true,class:"text-center",thStyle:'min-width:115px;'  },
				/* { key: 'mcb_status', label: 'MCB Status', 'extra': 1 }, */
				/* { key: 'meter_phase_type', label: 'P',sortable: true,}, */
				/* { key: 'modem_type', label: 'MT',  sortable: true,  sortDirection: 'desc' }, */
				{ key: 'geo_loc', label: 'GEO Location',thStyle:'min-width:115px;'},
				/* { key: 'sys_meter_no', label: 'MS', sortable: true,  
					formatter: (value, key, item) => {
						if(value == item.device_no){
							return 0;
						}
						return 1;
					},
				}, */
				
				{ key: 'output_status', label: 'Output' , thStyle:'min-width:100px;', 
					formatter: (value) => {
						//if(value == 0){
						//	return 'OFF';
						//}
						return value;
					},
				},
				{ key: 'overload', label: 'OL',sortable: true,  class: 'text-right',
					formatter: (value, key, item) => {
						var fault = 0;
						if(item.meter_type === '1P'){
							//fault = 100*((item.kw_r/10000) - (item.total_load/1000))/(item.total_load/1000) ;
							fault = 100*((item.kw_r) - (item.total_load))/(item.total_load) ;
						}else{
							//fault = 100*((item.total_kw/100000) - (item.total_load/1000))/(item.total_load/1000);
							fault = 100*((item.total_kw) - (item.total_load/1000))/(item.total_load/1000);
						}
						//console.log('item:'+item.imei_no+'------'+item.total_load);
						fault = 100*((item.total_kw) - (item.total_load/1000))/(item.total_load/1000);
						return fault.toFixed(1);		
					},
				},
				{ key: 'underload', label: 'UL', sortable: true, class: 'text-right',
					formatter: (value, key, item) => {
						var fault = 0;
						if(item.meter_type === '1P'){
							fault = 100*((item.total_load/1000) - (item.total_kw))/(item.total_load/1000) ;
						}else{
							fault = 100*((item.total_load/1000) - (item.total_kw/100000))/(item.total_load/1000);
						}
						if(fault>=99.9){
							fault = 100;
						}
						return fault.toFixed(1);		
					},
				},
				{ key: 'light_on', label: 'Light ON',sortable: true, thStyle:'min-width:100px;', class: 'text-center' },
				{ key: 'light_off', label: 'Light OFF',sortable: true, thStyle:'min-width:100px;', class: 'text-center' },
				/* { key: 'mode', label: 'Mode',sortable: true, class: 'text-center' }, */
				{ key: 'update_time', label: 'TimeStamp',thStyle:'min-width:130px;', 
					formatter: (value, key, item) => {
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm');
					},
				},
				{ key: 'connection_status', label: 'Network Status', sortable: true, thStyle:'min-width:130px;',
					formatter: (value, key, item) => {
						if(item.datalength == 0){
							return 3;
						}
						if(item.datalength != 59 && item.datalength != 210 && item.datalength != 236){
							return 2;
						}
						return value;
					}
				},
				{ key: 'actions', label: 'Actions', class:'text-center last-cal', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			selectedfilter: 'CONNECT',
			networkOptions: [{text:'All', value:-1}, {text:'Connected', value:1}, {text:'Disconnected', value:0}, {text:'Data Fault', value:2}, {text:'Pending', value:3}],
			powerOptions: [{text:'All', value:-1}, {text:'ON', value:1}, {text:'OFF', value:0}, {text:'Power Cut', value:2}],
			filteroptions: [{text:'All', value:'ALL'}, {text:'Connected', value:'CONNECT'}, {text:'Disconnected', value:'DISCONNECT'}, {text:'CCMS ON', value:'CCMSON'}, {text:'CCMS OFF', value:'CCMSOFF'}, {text:'Manual', value:'MANUAL'}, {text:'Power Cut', value:'PWROFF'}, {text:'Meter Cable Fault', value:'DATAFLT'}, {text:'Pending', value:'PENDING'}, {text:'Overload', value:'OVERLOAD'}, {text:'Underload', value:'UNDERLOAD'} ],
			pageOptions: [10, 20, 50, 100, 500, 1000, 2000],
			perPage: 1000,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				led_fittings: {}
			},
			replaceItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				ward_id: 0,
				device_type: 'CCMS',
				feeder_pillar_no: '',
				modem_type: '2G',
				vendor: 1,
				ward_no: '',
				consumer_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				meter_type: '3P',
				phase: 1,
				led_fittings: {
				},
				maintenance: 0,
				totla_previous_load:0,
			},
			center: { lat: 0, lng: 0 },
			markers: [],
			center2: { lat: 0, lng: 0 },
			markers2: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoneinfo: {},
			supervisorlist:[],
			device_group:[],
			complaints:[],
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			popup_fittings: {},
			physicalLoad:0,
			physicalLoad_rate:0,
			datefrom:'',
			underloadMode:'d-none',			
			tableHeight:'',
			penalheight:'',
			tabIndex:0,
			lighton:true,
			lightoff:false,
			checkbox: false,
			my_latitude:null,
			my_longitude:null,
			maplink:'https://www.google.com/maps/dir/',
			
		};
	},
	methods: {	
		
		in_schedule(curr_time, start_time, end_time){
			var self = this;
			if(start_time != '' && end_time!= '' && start_time != null && end_time!= null){
				var cal_start_time = parseFloat(start_time.split(":")[0]+'.'+start_time.split(":")[1]);
				var cal_end_time = parseFloat(end_time.split(":")[0]+'.'+end_time.split(":")[1]);
				var cal_curr_time = self.$moment(curr_time).format("HH.mm");

				var start_date = '';
				//var end_date = '';
				if(cal_start_time > cal_end_time){
					//console.log('>>> '+curr_time);
					if(cal_curr_time <= 24.00 && cal_curr_time > cal_start_time){
						//console.log(self.$moment(curr_time).format("YYYY-MM-DD"));
						start_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+start_time;
					//	end_date = self.$moment(curr_time).add(1, 'day').format("YYYY-MM-DD")+" "+end_time;
					}else if(cal_curr_time < cal_end_time){
						//console.log("ELSE IF");
						start_date = self.$moment(curr_time).subtract(1, 'day').format("YYYY-MM-DD")+" "+start_time;
					//	end_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+end_time;
					}else{
						//console.log("ELSE ");
						start_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+start_time;
					//	end_date = self.$moment(curr_time).add(1, 'day').format("YYYY-MM-DD")+" "+end_time;
					}
				}else{
					start_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+start_time;
				//	end_date = self.$moment(curr_time).format("YYYY-MM-DD")+" "+end_time;
				}
				//console.log(start_date);
				if(self.$moment(curr_time).diff(start_date, 'minutes') > 0){
					return true;
				}
			}
			return false;
		},
		viewdata(){
			//alert(this.selectedItem);
			var self = this;
			self.loading = true;
			
			self.axios.post(self.devicedataUrl, {
				accesskey: self.$session.get('access_key'),
				imei_no: self.selectedItem.imei_no
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.selectedItem.data = response.data.result.data;
				}
				self.loading = false;
			})
			.catch(function (error) {
				alert(error);
			});
		},
		sendCommand(cmd, imei){
			var o = new Object();
			o.imei = imei;
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser', o);
			}
		},
		onChangeEventHandler(imei,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei = imei;
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));			
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser', o);
			}
			this.initload();
		},
		onChangeEventPhaseHandler(imei,phase,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei 	= imei; 
			o.phase = phase; 
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));
			console.log('asdasd');
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser_phase', o);
			}
			this.initload();
		},
		lightonoffAll(cmd){
			var msgAlt = "Are you sure you want to turn "+cmd+" all your lights?"
			this.$bvModal.msgBoxConfirm(msgAlt, {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
						//console.log('ACTION:',cmd);
						var o = new Object();			
						o.imei = 'all';
						o.command = cmd;
						//console.log('Send Cmd:'+JSON.stringify(o));			
						if(this.$socket.connected){
							//console.log("All Light " + cmd +" CONNECTED AND LOADING DATA");
							
							this.$socket.emit('alllightonoff', o);
						}
						this.initload();
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})



		},
		showFittings(item, target){
			console.log(item.no_of_fittings+' '+target.id)
			this.popup_fittings_target = target.id;
			this.popup_fittings = item.no_of_fittings;
			//this.$refs.popover.$emit('open');
			this.$root.$emit('bv::show::popover', target.id);
			console.log("SHOW FITTINGS");
			
			
			//this.$refs.popover.$emit('show', target.id)
		},
		hideFittings(){
			console.log("HIDE FITTINGS");
			this.popup_fittings_target = "";
			this.$refs.popover.$emit('close');
		},
		onFilterChange(){
			//this.filteredrecords = this.vendorChange(this.phaseChange(this.networkChange(this.filterChange(this.records))));
			this.filteredrecords = this.vendorChange(this.phaseChange(this.wardChange(this.filterChange(this.records))));			
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
			if(this.totalRows<10){
				this.tableHeight ='min-height: auto;';
			}else{
				this.tableHeight = 'min-height:'+this.penalheight+'px;';
			}
		},
		onFilterDevices(){
			this.filteredrecords = this.phaseChange(this.filterDevices(this.records));
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
			if(this.totalRows<10){
				this.tableHeight ='min-height: auto;';
			}else{
				this.tableHeight = 'min-height:'+this.penalheight+'px;';
			}
		},
		filterWards(){
			var self = this;
			return self.wards.filter(function (item) {
				return item.ulb_id  == self.selectedItem.ulb_id;
			})
		},
		filterZones(){
			var self = this;
			return self.zones.filter(function (item) {
				return item.ulb_id  == self.selectedItem.ulb_id;
			})
		},
		vendorChange(devices){
			var self = this;
			return devices.filter(function (d) {
				if(self.vendorfilter == '0'){
					return d;
				}else{
					if(self.vendorfilter == d.vendor){
						return d;
					}
				}
			});
		},
		phaseChange(devices){
			var self = this;
			return devices.filter(function (d) {
				if(self.phasefilter == '0'){
					return d;
				}else{
					if(self.phasefilter == d.phase){
						return d;
					}
				}
			});
		},
		wardChange(devices){
			var self = this; 		
			//self.wardfilter =self.wardfilter.value;   
			var wardId = self.wardfilter.value;
			if (wardId === undefined) {
				wardId ='all';
			}
			return devices.filter(function (d) { 
     		if(wardId =='all'){
					return d;
				}
				else{          
					if(wardId == d.ward_id){					
							return d;						
					}					
				}
			});
		},
		networkChange(devices){
			var self = this;
			return devices.filter(function (d) {
				if(self.networkfilter === 0){
					return d;
				}
				else{
					if(self.networkfilter == "2G"){
						if(d.modem_type == '2G'){
							return d;
						}
					}
					else if(self.networkfilter == "4G"){
						if(d.modem_type == '4G'){
							return d;
						}
					}
				}
			});
		},
		filterChange(devices){
			var self = this;
			return devices.filter(function (d) {
				if(self.selectedfilter == 'ALL'){
					return d;
				}
				if(self.selectedfilter == 'CONNECT'){
					if(d.connection_status == 1 && d.datalength > 0){
						return d;
					}
				}
				if(self.selectedfilter == 'DISCONNECT'){
					if(d.connection_status == 0 && d.datalength > 0){
						return d;
					}
				}
				
				if(self.selectedfilter == 'CCMSON'){
					if(d.connection_status == 1 && d.output_status == 1){
						return d;
					}
				}
				if(self.selectedfilter == 'CCMSOFF'){
					if(d.connection_status == 1 && d.output_status == 0 && d.supply != 0){
						return d;
					}
				}
				if(self.selectedfilter == 'MANUAL'){
					if(d.connection_status == 1  && (d.datalength == 210 || d.datalength == 236)){
						if(d.output_status == 0 && (d.amp_r > self.$root.correction_amp || d.amp_y > self.$root.correction_amp || d.amp_b > self.$root.correction_amp)){
							return d;
						}

						
					}
				}
				
				if(self.selectedfilter == 'PWROFF'){
					if(d.connection_status == 1 && d.supply == 0){
						return d;
					}
				}
				if(self.selectedfilter == 'DATAFLT'){
					/* if(d.connection_status == 1 && d.datalength != 59 && d.datalength != 210 && d.datalength != 0 && d.datalength != 236){ */
					if(d.connection_status == 1 && d.supply>0 && d.datalength != 59 && d.datalength != 210 && d.datalength != 0 && d.amp_r==0 && d.amp_y==0 && d.amp_b==0 && d.voltage_r==0  && d.voltage_y==0  && d.voltage_b==0 && d.kwh==0){
						return d;
					}
				}
				if(self.selectedfilter == 'PENDING'){
					if(d.datalength == 0){
						return d;
					}
				}

				if(self.selectedfilter == 'OVERLOAD'){
					
					if(d.overload >self.overload_variable){
						return d;
					}
				}
				if(self.selectedfilter == 'UNDERLOAD'){
					if(d.underload > self.underload_variable){
						return d;
					}
				}
				

				
			});
		},
		filterDevices(devices){
			var self = this;
			return devices.filter(function (d) {
				var valid_network = false;
				var valid_power = false;
				


				if(self.networkfilter < 0){
					valid_network = true;
				}else if(self.networkfilter == 0){ // disconnected 
					if(d.connection_status == 0 && d.datalength > 0){
						valid_network = true;
					}
				}else if(self.networkfilter == 1){ // connected 
					if(d.connection_status == 1 && d.datalength > 0){
						valid_network = true;
					}
				}else if(self.networkfilter == 2){ // Data Fault 
					if(d.datalength != 59 && d.datalength != 210 && d.datalength != 0){
						valid_network = true;
					}
				}else if(self.networkfilter == 3){ // Pending 
					if(d.datalength == 0){
						valid_network = true;
					}
				}

				if(self.powerfilter < 0){
					valid_power = true;
				}else if(self.powerfilter == 0){ // OFF 
					if(d.output_status == 0){
						valid_power = true;
					}
				}else if(self.powerfilter == 1){ // ON 
					if(d.output_status == 1){
						valid_power = true;
					}
				}else if(self.powerfilter == 2){ // Power Failure 
					if(d.datalength == 59){
						valid_power = true;
					}
				}
				
				if(valid_network && valid_power){
					return d;
				}
			});
		},
		updateTotalLoad(){
			var self = this;
			var total_load = 0;
			var no_of_fittings = 0;
			console.log("UPDATE TORAL LAOD ");
			this.watts.forEach(function(value){
				if(self.selectedItem.led_fittings['w'+value]){
					no_of_fittings += parseInt(self.selectedItem.led_fittings['w'+value]);
					total_load += parseInt(self.selectedItem.led_fittings['w'+value]) * value;
				}
			});
			/*if(parseInt(this.selectedItem.led_18w) > 0){
				total_load += parseInt(this.selectedItem.led_18w) * 18;
			}
			if(parseInt(this.selectedItem.led_20w) > 0){
				total_load += parseInt(this.selectedItem.led_20w) * 20;
			}
			if(parseInt(this.selectedItem.led_24w) > 0){
				total_load += parseInt(this.selectedItem.led_24w) * 24;
			}
			if(parseInt(this.selectedItem.led_32w) > 0){
				total_load += parseInt(this.selectedItem.led_32w) * 32;
			}
			if(parseInt(this.selectedItem.led_35w) > 0){
				total_load += parseInt(this.selectedItem.led_35w) * 35;
			}
			if(parseInt(this.selectedItem.led_40w) > 0){
				total_load += parseInt(this.selectedItem.led_40w) * 40;
			}
			if(parseInt(this.selectedItem.led_45w) > 0){
				total_load += parseInt(this.selectedItem.led_45w) * 45;
			}
			if(parseInt(this.selectedItem.led_50w) > 0){
				total_load += parseInt(this.selectedItem.led_50w) * 50;
			}
			if(parseInt(this.selectedItem.led_60w) > 0){
				total_load += parseInt(this.selectedItem.led_60w) * 60;
			}
			if(parseInt(this.selectedItem.led_70w) > 0){
				total_load += parseInt(this.selectedItem.led_70w) * 70;
			}
			if(parseInt(this.selectedItem.led_72w) > 0){
				total_load += parseInt(this.selectedItem.led_72w) * 72;
			}
			if(parseInt(this.selectedItem.led_75w) > 0){
				total_load += parseInt(this.selectedItem.led_75w) * 75;
			}
			if(parseInt(this.selectedItem.led_80w) > 0){
				total_load += parseInt(this.selectedItem.led_80w) * 80;
			}
			if(parseInt(this.selectedItem.led_90w) > 0){
				total_load += parseInt(this.selectedItem.led_90w) * 90;
			}
			if(parseInt(this.selectedItem.led_100w) > 0){
				total_load += parseInt(this.selectedItem.led_100w) * 100;
			}
			if(parseInt(this.selectedItem.led_110w) > 0){
				total_load += parseInt(this.selectedItem.led_110w) * 110;
			}
			if(parseInt(this.selectedItem.led_120w) > 0){
				total_load += parseInt(this.selectedItem.led_120w) * 120;
			}
			if(parseInt(this.selectedItem.led_130w) > 0){
				total_load += parseInt(this.selectedItem.led_130w) * 130;
			}
			if(parseInt(this.selectedItem.led_140w) > 0){
				total_load += parseInt(this.selectedItem.led_140w) * 140;
			}
			if(parseInt(this.selectedItem.led_150w) > 0){
				total_load += parseInt(this.selectedItem.led_150w) * 150;
			}
			if(parseInt(this.selectedItem.led_190w) > 0){
				total_load += parseInt(this.selectedItem.led_190w) * 190;
			}
			if(parseInt(this.selectedItem.led_200w) > 0){
				total_load += parseInt(this.selectedItem.led_200w) * 200;
			}
			if(parseInt(this.selectedItem.led_250w) > 0){
				total_load += parseInt(this.selectedItem.led_250w) * 250;
			}
			if(parseInt(this.selectedItem.led_400w) > 0){
				total_load += parseInt(this.selectedItem.led_400w) * 400;
			}*/
			this.selectedItem.total_load = total_load;
			
			this.selectedItem.no_of_fittings = no_of_fittings;
		},
		setMaintenance(val){
			var self = this;
			var maintenance_flag = -1;
			if(val.trigger == "maintenance_on"){
				maintenance_flag = 1;
			}
			else if(val.trigger == "maintenance_off"){
				maintenance_flag = 0;
			}

			if(maintenance_flag >= 0){
				var submitdata = new Object();
				submitdata.feeder_pillar_no = self.selectedItem.feeder_pillar_no;
				submitdata.maintenance = maintenance_flag;

				self.loading = true;
				//bvModalEvt.preventDefault();

				self.axios.post(self.maintenanceUrl, {
					accesskey: self.$session.get('access_key'),
					data: submitdata
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('view-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		/* toogleMarkerInfoWindow(marker, index){
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		}, */
		 toogleMarkerInfoWindow(marker, index) {
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext; // Show full info
			
			if (this.currentMarkerIndex === index) {
			this.infoWindowOpen = !this.infoWindowOpen;
			} else {
			this.infoWindowOpen = true;
			this.currentMarkerIndex = index;
			}
		},
		/* showMarkerTooltip(marker, index) {
			console.log('marker', marker);
			// Extract just the CCMS ID from the info text for the tooltip
			const ccmsIdMatch = marker.infotext.match(/CCMS ID: ([^<]+)<br>/);
			console.log('ccmsIdMatch:',JSON.stringify(ccmsIdMatch));
			const simpleContent = ccmsIdMatch ? `<b>${ccmsIdMatch[1]}</b>` : '<b>CCMS Device</b>';
			
			this.infoOptions.content = simpleContent;
			this.infoWindowPos = marker.position;
			this.currentMarkerIndex = index;
			this.infoWindowOpen = true;
		}, */
		showMarkerTooltip(marker, index) {
			console.log('marker', marker);

			// Extract just the CCMS ID (ignores tags)
			const ccmsIdMatch = marker.infotext.match(/CCMS ID:\s*([^<]+)/i);			
			const simpleContent = ccmsIdMatch
				? `<b>FP No: ${ccmsIdMatch[1]}</b>`
				: '<b>CCMS Device</b>';

			this.infoOptions.content = simpleContent;
			this.infoWindowPos = marker.position;
			this.currentMarkerIndex = index;
			this.infoWindowOpen = true;
			},
		
		hideMarkerTooltip() {
			// Only hide if we're showing a tooltip (not the full info window)
			if (!this.infoWindowOpen || this.infoOptions.content.includes('CCMS ID:')) {
			this.infoWindowOpen = false;
			}
		},
		addMarker(lat, lng, infotext, iconurl,lable) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//console.log('lable::', lable);  labelOrigin: new google.maps.Point(15, -10)
			return { position: marker, infotext: infotext,lable:lable, icon: {url:iconurl,size: {width: 20, height: 28, f: 'px', b: 'px'}, scaledSize: {width: 20, height: 28, f: 'px', b: 'px',}} };
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			//this.center = marker;
			//this.currentPlace = null;
		},
		addMarker2(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 60, height: 90, f: 'px', b: 'px'}, scaledSize: {width: 30, height: 45, f: 'px', b: 'px',}} });
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.ulb_id  == self.selectedItem.ulb_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state == self.selectedItem.state_id;
			})
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.zoneOptions.forEach(function(field){
				if(field.areacode == self.selectedUlb){
					self.selectedItem.state_id = field.state;
					if(field.parent > 0){
						self.selectedItem.zone_id = field.parent;
					}
					if(field.parent > 0){
						self.selectedItem.ulb_id = field.id;
					}
				}
			});
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);

			var fittings = {};
			this.watts.forEach(function(value){
				fittings['w'+value] = item.led_fittings['w'+value];
			});
			this.selectedItem.led_fittings = fittings;
			this.$root.$emit('bv::show::modal', 'edit-model', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showReplaceModal(item, button){
			this.replaceItem = {
				replace_imei_no: item.imei_no,
				replace_meter_no: item.device_no,
				feeder_pillar_no: item.feeder_pillar_no,
				new_imei_no: '',
				new_meter_no: '',
				mobile_no: item.mobile_no,
				replace_time: '',
				comment: ''
			};
			this.$root.$emit('bv::show::modal', 'replace-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		onReplaceDevice(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.replaceUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.replaceItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('replace-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}else if(response.data.error == 1){
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});

				}else{
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});

				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}
			
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}else{
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zones = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadulbs(){
			var self = this;
			
			self.axios.post(self.ulbsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					self.zoneOptions.forEach(function(field){
						//if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;
										return;
									}
								});
							}
						//}
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadDevicegroup(){
			var self = this;
			
			self.axios.post(self.groupUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.deviceGroup = response.data.result;
					/* self.zoneOptions.forEach(function(field){
						//if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;
										return;
									}
								});
							}
						//}
					}); */
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadwards(){
			var self = this;
			
			/* Current My Location  */
			self.getLocation();
			
			
			self.axios.post(self.wardsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.wards = response.data.result;

					self.wardfilterlist=[];
						self.wardfilterlist.push({'value':'all','text':'All Wards'});
						self.wards.forEach(function(row){
							var supList ={'value':row.id,'text':row.areacode};
							self.wardfilterlist.push(supList);							
						});


				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				ulbcode: self.selectedUlb,
				limit: 40,
				index: 0
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.ulb_devices;
					self.zoneinfo = response.data.result.zoneinfo;
					self.supervisorlist = response.data.result.supervisors;
					self.device_group = response.data.result.device_group;
					self.complaints = response.data.result.complaints;					
					self.loading = false;
					self.totalRows = self.records.length;
					
					self.last_sync_time = self.$moment(response.data.result.time).format('YYYY-MM-DD HH:mm:ss');

					self.total_power_cut = 0;

					self.total_lights = 0;
					self.total_light_on = 0;
					self.total_light_off = 0;
					self.total_signal_loss = 0;

					self.total_manual = 0;
					self.total_pending = 0;

					self.current_load = 0;
					self.off_load = 0;
					self.direct_load = 0;
					self.signal_loss_load = 0;
					self.total_load = 0;
					self.totla_previous_load =0;

					self.fixed_load = self.zoneinfo.fixed_load * 1000;
					self.fixed_led = self.zoneinfo.fixed_led;

					self.total_kwh = 0;

					self.device_on = 0;
					self.device_connected = 0;
					self.total_complaints = 0;
					self.total_overload= 0;
					self.total_underload=0;
					self.total_light_on_overload=0;
					self.total_light_off_overload=0;
					self.total_light_on_underload=0;
					self.total_light_off_underload=0;

					var sno = 1;

					//self.fault_records = [];

					//var x = 0;

					//var meter_fault = 0;
					self.records.forEach(function(field){
						field.sno = sno++;

						field.led_fittings = JSON.parse(field.led_fittings);

						self.total_lights += field.no_of_fittings;
						
						self.total_load += parseInt(Number(field.total_load));
						

						//self.physicalLoad = self.$root.tofixed((((self.total_load/1000)*38)/100)*365*11,2);
						self.physicalLoad = self.$root.tofixed((((self.total_load/1000)*6)/100)*365*11,2);
						//self.physicalLoad_rate = self.$root.tofixed((((((self.total_load/1000)*21)/100)*365)*8.5)/1000000,2);
						self.physicalLoad_rate = self.$root.tofixed((self.physicalLoad*12.72)/10000000,2);

						self.totla_previous_load +=parseInt(Number(field.previous_load));
						//console.log('==============IME:'+field.imei_no+'TOTAL LOAD INDIVISUAL:'+field.total_load+'=====totla_previous_load'+self.totla_previous_load);

						if(field.kwh && field.kwh != 'NaN'){
							self.total_kwh += parseInt(field.kwh);
						}

						self.server_time = response.data.result.time;
						var curdatetime = self.$moment(response.data.result.time); // i will replace this with server time by passing time in api
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
						
						
						if(field.update_time == "" || field.update_time == null || field.update_time == 'null' || field.update_time.length < 10){
							conn_status = 3;

							//console.log("::: "+field.update_time+' PENDING');
						}else{
							dbdatetime = self.$moment(field.update_time);
							//console.log(curdatetime+'-----------'+dbdatetime);
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
						
							var disconnection_time = self.$session.get('disconnection_time');
							//console.log('minutes:'+minutes+'--disconnection_time:'+disconnection_time);
							if(minutes < disconnection_time){
								
								conn_status = 1;
							}else{
								
								conn_status = 0;
							}
							var userinfo = self.$session.get('user_info');
							
							if(userinfo.role == 1 || userinfo.role == 4 || userinfo.role == 10 || userinfo.role == 11 || userinfo.role == 14  || userinfo.role == 16){
								var days = 0;
								var hrs = 0;
								var mins = 0;
								if(minutes < 60){
									field.last_event = parseInt(minutes)+' Minutes ago';
								}else if(minutes >= 60 && minutes < 60 * 24){
									hrs = parseInt(minutes / 60);
									mins = parseInt(minutes % 60);
									field.last_event = hrs+ ' Hours '+mins+' Minutes ago';
								}else{
									days = minutes / (60 * 24);
									hrs = (days % parseInt(days)) * 24;
									if(hrs < 1){
										mins = hrs * 60;
									}else{
										mins = (hrs % parseInt(hrs)) * 60;
									}
									
									field.last_event = parseInt(days)+ ' Days '+parseInt(hrs)+ ' Hours '+parseInt(mins)+' Minutes ago';
								}
							}
						}
						
						field.connection_status = conn_status;

						//item.datalength != 59 && item.datalength != 210 && item.datalength != 236
						//if(d.connection_status == 1 && d.datalength != 59 && d.datalength != 210 && d.datalength != 0){

						if(conn_status==0){
							field.total_kw = 0;
						}

						if(conn_status == 1 && (field.supply < 120 || field.supply == 0)){
							self.total_power_cut += 1;
						}

						if(conn_status == 1){
							self.device_connected += 1;
						}
						if(field.connection_status == 1 && field.output_status == 1 && conn_status == 1){
							self.device_on += 1;
							self.total_light_on += field.no_of_fittings;
						}
						if(field.connection_status == 1 && field.output_status == 0 && conn_status == 1){
							self.total_light_off += field.no_of_fittings;
						}
						if(conn_status == 0){
							self.total_signal_loss += field.no_of_fittings;
						}
						if(conn_status == 3){
							self.total_pending += field.no_of_fittings;
						}

						field.geo_loc = field.location_lat+','+field.location_lng;

						if(conn_status == 0 || (field.output_status == 0 && (parseInt(field.amp_r/1000) < self.$root.correction_amp || parseInt(field.amp_y/1000) < self.$root.correction_amp || parseInt(field.amp_b/1000) < self.$root.correction_amp))){
							// do nothing
						}else{
							if(field.meter_type === '1P'){
								if(field.kw_r && field.kw_r != 'NaN') {
									self.current_load += parseFloat(field.total_kw);// * 10000;
								}
							}else{
								if(field.total_kw && field.total_kw != 'NaN') {
									self.current_load += parseInt(field.total_kw);
								}
							}
						}
						

						field.mode = 0;
						if(field.output_status == 0){
						//	if(field.meter_type === '1P'){
						//		if(field.kw_r/1000 > 0.1){
						//			field.mode = 1;
						//		}
						//	}else{
						//		if(field.total_kw > 0.2){
									field.mode = 1;
						//		}
						//	}
						}



						if(conn_status == 1){
							if(field.output_status == 0){
								//console.log((++x)+" "+field.imei_no+" "+field.total_kw);
								self.off_load += parseFloat(field.total_load);
								if(parseFloat(field.amp_r) > self.$root.correction_amp || parseFloat(field.amp_y) > self.$root.correction_amp || parseFloat(field.amp_b) > self.$root.correction_amp){
									/*field.amp_r = 0;
									field.amp_y = 0;
									field.amp_b = 0;

									field.kw_r = 0;
									field.kw_y = 0;
									field.kw_b = 0;

									field.total_kw = 0;*/
									field.mode = 0;
									self.current_load += parseFloat(field.total_kw);
									self.direct_load += parseFloat(field.total_kw);
								}else{
									
									field.total_kw = 0;
								}
							}else{
								if(field.total_kw < 100 && field.total_kw > 0.2){
									self.current_load += parseFloat(field.total_kw);
								}
							}
						}else{
							//console.log(field.total_load);
							self.signal_loss_load += parseFloat(field.total_load);
						}

						/*if(field.output_status == 0){
							if(parseFloat(field.amp_r) > self.$root.correction_amp || parseFloat(field.amp_y) > self.$root.correction_amp || parseFloat(field.amp_b) > self.$root.correction_amp){
							*/	/*field.amp_r = 0;
								field.amp_y = 0;
								field.amp_b = 0;

								field.kw_r = 0;
								field.kw_y = 0;
								field.kw_b = 0;

								field.total_kw = 0;*/
							/*	field.mode = 0;
								//self.current_load += parseFloat(field.total_kw);
								self.direct_load += parseFloat(field.total_kw);
							}else{
								self.off_load += parseFloat(field.total_kw);
							}
						}else{
							field.mode = 0;
							if(conn_status == 1){
								if(field.total_kw < 100 && field.total_kw > 0.2){
									self.current_load += parseFloat(field.total_kw);
								}
							}else{
								if(conn_status == 0){
									self.off_load += parseFloat(field.total_kw);
								}
							}
						}*/

						

						/* **************** OverLoad Underload ********  */
						var faultOverload = 0;
						faultOverload = 100*((field.total_kw) - (field.total_load/1000))/(field.total_load/1000);

						field.overload = faultOverload.toFixed(1);
						if(field.overload>self.overload_variable){
							if(field.output_status == 1){
								self.total_overload++;
							
								if(field.light_on>0){
									self.total_light_on_overload=Number(self.total_light_on_overload)+Number(field.light_on);
								}
								if(field.light_on>0){
									self.total_light_off_overload=Number(self.total_light_off_overload)+Number(field.light_off);
								}
							}
						}

						var faultUnderload = 0;
						if(field.meter_type === '1P'){
							faultUnderload = 100*((field.total_load/1000) - (field.total_kw))/(field.total_load/1000) ;
						}else{
							faultUnderload = 100*((field.total_load/1000) - (field.total_kw/100000))/(field.total_load/1000);
						}
						if(faultUnderload>=99.9){
							faultUnderload = 100;
						}
						if(field.output_status == 1){
							field.underload = faultUnderload.toFixed(1);
							if(field.underload>self.underload_variable){
								
								self.total_underload++;

								if(field.light_on>0){
									self.total_light_on_underload=Number(self.total_light_on_underload)+Number(field.light_on);
								}
								if(field.light_on>0){
									self.total_light_off_underload=Number(self.total_light_off_underload)+Number(field.light_off);
								}
								
							}
						}

						/* *************************** */

						if(conn_status == 1 && (field.datalength == 210 || field.datalength == 236)){
							if(field.output_status == 0 && (field.amp_r > self.$root.correction_amp || field.amp_y > self.$root.correction_amp || field.amp_b > self.$root.correction_amp)){
								self.total_manual += 1;
								self.device_on += 1;
								self.total_light_on += field.no_of_fittings;
							}
						}
						
						/* ===================END fault_records================================
						var p2;

						var systemtime = self.$moment(field.update_time);

						var dev_on_time = self.zoneinfo.on_time;
						var dev_off_time = self.zoneinfo.off_time;
						/* if(field.on_time!='' && field.on_time!='null' ){
							dev_on_time = field.on_time;
						}
						if(field.off_time!='' && field.off_time!='null' ){
							dev_off_time = field.on_time;
						} */
						/*
						var schedule_ontime = self.$moment(systemtime.format('YYYY-MM-DD '+dev_on_time+':00'));
						var schedule_offtime = self.$moment(systemtime.format('YYYY-MM-DD '+dev_off_time+':00'));

						var schedule_ontime_check = self.$moment.duration(systemtime.diff(schedule_ontime)).asMinutes();
						var schedule_offtime_check = self.$moment.duration(systemtime.diff(schedule_offtime)).asMinutes();

						//console.log("ON TIME : "+self.zoneinfo.on_time+'====imei_ON'+field.on_time);
						//console.log("OFF TIME : "+schedule_offtime+'====imei_OFF'+field.off_time);


						if((schedule_ontime_check > 0 && schedule_offtime_check > 0) || (schedule_ontime_check < 0 && schedule_offtime_check < 0)){
							//console.log("IN SHEDULE");
							//if(field.connection_status == 1 && field.output_status == 1 && conn_status == 1 && field.supply != 0){
							if(field.connection_status == 1 && conn_status == 1 && field.supply != 0){
								if((parseFloat(field.amp_r) < self.$root.correction_amp && parseFloat(field.amp_y) < self.$root.correction_amp && parseFloat(field.amp_b) < self.$root.correction_amp)){
									p2 = Object.assign({}, field);
									self.fault_records.push(p2);
								}
							}
						}else if(schedule_ontime_check < 0 && schedule_offtime_check > 0 && field.supply != 0){
							//if(field.connection_status == 1 && field.output_status == 0 && conn_status == 1){
							if(field.connection_status == 1 && conn_status == 1){
								if((parseFloat(field.amp_r) > self.$root.correction_amp || parseFloat(field.amp_y) > self.$root.correction_amp || parseFloat(field.amp_b) > self.$root.correction_amp)){
									p2 = Object.assign({}, field);
									self.fault_records.push(p2);
								}
							}
						}
						// ===================END fault_records================================
						*/
						/*if(curdatetime > currenttime){
							duration = self.$moment.duration(curdatetime.diff(dbdatetime));
						}else{
							duration = self.$moment.duration(dbdatetime.diff(curdatetime));
						}
						minutes = duration.asMinutes();
						var disconnection_time = self.$session.get('disconnection_time');
						if(minutes < disconnection_time){
							conn_status = 1;
						}else{
							conn_status = 0;
						}*/
						
						/*if(field.connection_status == 1 && field.output_status == 1 && conn_status == 1){
							if((parseInt(field.amp_r/1000) < self.$root.correction_amp || parseInt(field.amp_y/1000) < self.$root.correction_amp || parseInt(field.amp_b/1000) < self.$root.correction_amp)){
								p2 = Object.assign({}, field);
								self.fault_records.push(p2);
							}
						}else if(field.connection_status == 1 && field.output_status == 0 && conn_status == 1){
							if((parseInt(field.amp_r/1000) > self.$root.correction_amp || parseInt(field.amp_y/1000) > self.$root.correction_amp || parseInt(field.amp_b/1000) > self.$root.correction_amp)){
								p2 = Object.assign({}, field);
								self.fault_records.push(p2);
							}
						}*/


					});

					//alert(self.zoneinfo.on_time +" "+ self.zoneinfo.off_time);
					//self.zoneinfo.on_time = '17:00';
					//self.zoneinfo.off_time = '19:00';
					var inschedule = self.in_schedule(self.last_sync_time, self.zoneinfo.on_time, self.zoneinfo.off_time);
					//alert("IN SHECC"+inschedule+" "+self.last_sync_time);
					if( inschedule ){
						self.check_inschedule = true;
						//console.log("FIXED: "+self.fixed_load+"  CURRENT:"+(self.current_load*1000)+"  OFF:"+self.off_load+"  LOSS:"+self.signal_loss_load+"  TOTAL: "+self.total_load);
						self.direct_load = self.fixed_load - (self.current_load*1000) - self.off_load - self.signal_loss_load;
					}else{
						self.check_inschedule = false;
						self.off_load = 0;
						self.signal_loss_load = 0;
						self.direct_load = 0;
					}

					
					
					//console.log("METER FAULT "+meter_fault);
					//self.filteredrecords = self.filterChange(self.records);//self.filterDevices(self.records);
					
					//self.filteredrecords = self.vendorChange(self.phaseChange(self.networkChange(self.filterChange(self.records))));
					self.filteredrecords = self.vendorChange(self.phaseChange(self.wardChange(self.filterChange(self.records))));


					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;

					self.markers = [];
					self.markers2 = [];
					var geoloc = [];
					//if(self.markers.length == 0 || self.records.length != self.markers.length){






						for (var i = 0; i < self.records.length; i++) {
							var d = self.records[i];
							var actual_load = 0;
							var pl = 0
							//if(parseInt(d.total_kw/100000) > 0.5){
							//	actual_load = (d.total_kw/100000).toFixed(3);
							//}

							//if(d.meter_type === '1P'){
								actual_load = d.total_kw;
								pl = (d.total_load/1000).toFixed(3);
							//}else{
							//	actual_load = (d.total_kw/100000).toFixed(3);
							//}
							var trackLoc = 'https://www.google.com/maps/dir/'+self.my_latitude+','+self.my_longitude+'/'+d.location_lat+','+d.location_lng;
							var msg = '<b>CCMS ID: '+d.feeder_pillar_no+'</b><br><b>Location</b> : '+d.location+'<br><b>Latitude :</b> '+d.location_lat+'<br><b>Longitude :</b> '+d.location_lng+'<br><b>Total Lamps Connected :</b> '+d.no_of_fittings+'<br><b>Physical Load KW :</b> '+pl+'<br><b>Actual Load KW :</b> '+actual_load+'<br><b>Last Updated Time :</b> '+self.$moment(d.update_time).format('DD-MM-YYYY HH:mm:ss')+'<br /><b><a href="'+trackLoc+'" target="_blank" class="trackMe"><div>Track Me</div></a></b>';

							var lable = d.feeder_pillar_no;

							min_lat = Math.min(d.location_lat, min_lat);
							min_lng = Math.min(d.location_lng, min_lng);

							max_lat = Math.max(d.location_lat, max_lat);
							max_lng = Math.max(d.location_lng, max_lng);

							/* var blueurl = "https://www.fablurs.com/flag-blue.png";
							var redurl = "https://www.fablurs.com/flag-red.png";
							var greenurl = "https://www.fablurs.com/flag-green.png"; */


							var blueurl = "https://nhaihyd.ccms.live/icon/pin-blue.png";
							var redurl = "https://nhaihyd.ccms.live/icon/pin-red.png";
							var greenurl = "https://nhaihyd.ccms.live/icon/pin-green.png";
							var whiteurl = "https://nhaihyd.ccms.live/icon/pin-white.png";
							var iconMyLocation = "https://nhaihyd.ccms.live/icon/pin-myself.png";

							//var blackurl = "https://nhaihyd.ccms.live/icon/pin-black.png";
							
							var iconurl = blueurl;
							if(d.connection_status == 1){
								if(d.output_status == 1){
									iconurl = greenurl;
								}else{
									iconurl = redurl;
								}

								if(d.supply < 120 || d.supply == 0){
									iconurl = whiteurl;
								}
							}
							
							/* var imeiNo = d.imei_no;
							self.complaints.forEach(citem=>{
								if(citem.imei_no==imeiNo){
									iconurl = blackurl;
									self.total_complaints++;
								}

							}); */


							/* if(conn_status == 1 && (field.supply < 120 || field.supply == 0)){
								self.total_power_cut += 1;
							} */
							
							geoloc.push(self.addMarker(self.records[i].location_lat, self.records[i].location_lng, msg, iconurl,lable));
						}
					if (self.my_latitude > 0 && self.my_longitude > 0) {

						
						var msgMylocation = 'My Location: <br><b>Latitude :</b> ' + self.my_latitude + '<br><b>Longitude :</b> ' + self.my_longitude;
						var mylable = 'My Self'; 						
						geoloc.push(self.addMarker(self.my_latitude,self.my_longitude, msgMylocation, iconMyLocation,mylable));
							
						}
						


						self.markers = geoloc;
						self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
					//}

					self.total_overload_percent=0;
					self.total_underload_percent=0;
					if(self.device_on>0){
						self.total_overload_percent= self.$root.tofixed(((self.total_overload/self.device_on)*100),2);
						self.total_underload_percent= self.$root.tofixed(((self.total_underload/self.device_on)*100),2);

						
					}

					self.interval = setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				self.interval = setTimeout(self.initload, self.$root.reload_duration);
				console.log(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
			if(this.totalRows<10){
				this.tableHeight ='min-height: auto;';
			}else{
				this.tableHeight = 'min-height:'+this.penalheight+'px;';
			}
		},
		downloadcsv(){
			var self = this;
			var header = new Array();
			var finalarr = new Array();
			var data = [...self.filteredrecords];

			/* overload underload csv download */
			var userinfo = this.$session.get('user_info');
			var uldata =[];
			var downloadFilename ='';
			self.ignorefields.splice('overload');
			self.ignorefields.splice('underload');
			if(self.selectedfilter=='UNDERLOAD' || self.selectedfilter=='OVERLOAD'){
				self.ignorefields.splice('overload');
				self.ignorefields.splice('underload');
				data.forEach(function(row){
					if(self.selectedfilter=='OVERLOAD'){
						//console.log('----------OVERLOAD--------------');
						downloadFilename = '_overload';
						self.ignorefields.push('underload');
						//self.ignorefields.pop('underload');
						if(row.overload>self.overload_variable){
							uldata.push(row);
						}
					}
					if(self.selectedfilter=='UNDERLOAD'){
						

						downloadFilename = '_underload';
						self.ignorefields.push('overload');
						//self.ignorefields.pop('overload');
						if(row.underload>self.underload_variable){
							//console.log(row.imei_no+'========'+index+'=======overload'+row.overload+'----Underload'+row.underload);
							//data.splice(index, 1);
							uldata.push(row);
						}
					}
				});

				data =uldata;
			}else{
				self.ignorefields.splice('overload');
				self.ignorefields.splice('underload');
			}
			//console.log(JSON.stringify(uldata));
			

			//data[0].forEach(function(item){
				for (const [key] of Object.entries(data[0])) {
					if(self.ignorefields.indexOf(key) < 0){

						if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11 && userinfo.role != 14){
							if(self.hidden_fields.indexOf(key) < 0){
								header.push(key);
							}
						}else{
							if(key == 'led_fittings'){
								// ide	
							}else{
								header.push(key);
							}
						}

					}
				}

				/* this.watts.forEach(function(value){
					header.push('w'+value);
				}); */


			//});
			
			finalarr.push(header);
			data.forEach(function(row){
				





				var dataarr = new Array();
				//var led_fittings = '';
				for (const [key,value] of Object.entries(row)) {
					//console.log('key:'+key+"value"+value);

					
					
					if(self.ignorefields.indexOf(key) < 0){

						if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11 && userinfo.role != 14){
							if(self.hidden_fields.indexOf(key) < 0){
								
								if(key == 'total_load'){
									dataarr.push((value/1000).toFixed(3));
								}else if(key == 'led_fittings'){
									// hide
									
								}else if(key == 'total_kw'){
									dataarr.push(parseFloat(value).toFixed(3));
								}else if(key === 'location'){
										if(value == ''){
											dataarr.push("");	
										}else{
											dataarr.push(value.replaceAll(","," "));
										}
								}else if(key === 'geo_loc'){
										dataarr.push(value.replaceAll(","," "));
								}else if(key === 'output_status'){
										if(value == 1){
											dataarr.push('ON');
										}else{
											dataarr.push('OFF');
										}
								}else if(key == 'door_status'){
									if(value ==1){
										
										dataarr.push('OPEN');
									}else{
										
										dataarr.push('CLOSED');
									}
									dataarr.push(value);

								}else if(key === 'ward_id'){
									if (value != '' && value > 0) {
										var wardName = self.wards.filter(function (itemm) {
											return itemm.id == value;
										})[0].title;
										dataarr.push(wardName.replace(",", " "));
									} 
									else {
										dataarr.push('---');
									 }
								}else if(key ==='meter_type'){
									if(value=='1P'){
									dataarr.push('3P');
									}else{
										dataarr.push(value);
									}
								}else{
										dataarr.push(value);
								}

							}
						}else{
							if(key == 'total_load'){
								/*if(row.meter_type === '1P'){
									dataarr.push((value/10000).toFixed(3));
								}else{
									dataarr.push((value/1000).toFixed(3));
								}*/
								dataarr.push((value/1000).toFixed(3));
							}else if(key == 'led_fittings'){
								// hide
								
							}else if(key == 'total_kw'){
								/*if(row.meter_type === '1P'){
									dataarr.push((row.kw_r/10000).toFixed(3));
								}else{
									dataarr.push((value/100000).toFixed(3));
								}*/
								dataarr.push(parseFloat(value).toFixed(3));
							}else if(key === 'location'){
								if(value == ''){
									dataarr.push("");	
								}else{
									if(value != null){
										dataarr.push(value.replaceAll(","," "));
									}else{
										dataarr.push("");
									}
									
								}
							}else if(key === 'geo_loc'){
								dataarr.push(value.replaceAll(","," "));
							}else if(key === 'output_status'){
								if(value == 1){
									dataarr.push('ON');
								}else{
									dataarr.push('OFF');
								}
							}else if(key === 'door_status'){
									if(value ==1){										
										dataarr.push("OPEN");
									}else{
										dataarr.push("CLOSED");
									}

								}else if(key ==='ward_id'){
									if (value != '' && value > 0) {
										var wardNamed = self.wards.filter(function (itemm) {
											return itemm.id == value;
										})[0].title;
										dataarr.push(wardNamed.replace(",", " "));
									} else {
										dataarr.push('---');
									}
								}else if(key ==='overload'){
									if(value>self.overload_variable){
										dataarr.push(value+'%');
									}else{
										dataarr.push(0+'%');
									}
									
								}else if(key ==='underload'){
									if(value>self.underload_variable){
									dataarr.push(value+'%');
									}else{
										dataarr.push(0+'%');
									}
								}else if(key ==='meter_type'){
									if(value=='1P'){
									dataarr.push('3P');
									}else{
										dataarr.push(value);
									}
								}else{	
								dataarr.push(value);
								}
						}

						/*if(key == 'led_fittings'){
							
						}*/
						

						
						//led_fittings = row.led_fittings;
					}
				}

				/* var fittings = row.led_fittings;
				var leds = self.watts;
				for(var i=0; i<leds.length; i++){
					if(fittings['w'+leds[i]]){
						dataarr.push(fittings['w'+leds[i]]);
					}else{
						dataarr.push(0);	
					}
				} */
				
				finalarr.push(dataarr);
			});
			//console.log(JSON.stringify(finalarr));
			/* if(self.selectedfilter=='OVERLOAD'){
				var dataId =[];
				finalarr.forEach((items, index)=>{
					//console.log(JSON.stringify(items)+'===='+index);
					console.log('-----------'+index+'======='+items.overload);
					dataId.push(items);

				});
				//console.log(JSON.stringify(dataId));
				

			} */
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report"+downloadFilename+".csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		
		mobilenodownload(){
			var self = this;

			//var finalarr = new Array();
			var data = [...self.filteredrecords];
			var dataarr = new Array();
			data.forEach(function(row){
			//var led_fittings = '';
			for (const [key,value] of Object.entries(row)) {
			//console.log('key:'+key+"value"+value);
			if(self.ignorefields.indexOf(key) < 0){
			if(key == 'mobile_no'){					
			dataarr.push(value)
			}
			}
			}
			});
			//console.log('dataarr'+dataarr);

			 var downloadFilename =self.$moment().format('DD-MM-YYYY HH:mm:ss');
			let csvContent = "data:text/csv;charset=utf-8," 
			+ dataarr;

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_mobiles_"+downloadFilename+".txt");
			document.body.appendChild(link); // Required for FF
			link.click();
		},
		setonoffTime(e){
			//var dddd = this.device_group['1'];
         //alert('this is selected Index ' + JSON.stringify(dddd)+'====='+index);
		// let index = event.target.selectedIndex;
			console.log(e);
			//this.selectedItem.on_time =event;
			//this.initload() ;


			if(e==0){
					this.selectedItem.on_time	= '00:00';			
					this.selectedItem.off_time	=  '00:00';	
				}else{				
					let optionindex 			= document.getElementById('groupoptionid').selectedIndex;
					if(optionindex>0){
						//console.log(JSON.stringify(this.device_group));
						optionindex=optionindex-1;
					var groupData 				= this.device_group[optionindex];		
					//console.log('groupData:'+JSON.stringify(groupData));		
					this.selectedItem.on_time	= groupData.on_time;			
					this.selectedItem.off_time	= groupData.off_time;
					}else{
						this.selectedItem.on_time	= '00:00';			
						this.selectedItem.off_time	= '00:00';

					}
					
					this.initload();
					
				}

		},
		showfilteroverload(){
			this.selectedfilter='OVERLOAD';
			this.onFilterChange();

		},
		showfilterunderload(){
			//console.log('asdasd');
			this.selectedfilter='UNDERLOAD';
			this.onFilterChange();

		},
		showUnderload(){
			this.underloadMode='';
			this.tabIndex=1;
		},
		onScroll() {
			//var windowTop = e.target.documentElement.scrollTop;
			var height = window.innerHeight;
     		 //console.log('-----height:'+height);
			//console.log('scrollHeight'+e.target.documentElement.scrollHeight);	
			this.penalheight =parseInt((height*78)/100);
			this.tableHeight ='min-height: '+this.penalheight+'px;';
			if(this.totalRows<10){
				this.tableHeight ='min-height: auto;';
			}

		},
		getLocation() {
			if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
			(position) => {
				this.my_latitude = position.coords.latitude;
				this.my_longitude = position.coords.longitude;
				console.log(
				"Lat/long:: " +
					position.coords.latitude +
					" --- " +
					position.coords.longitude
				);
			},
			(error) => {
				console.error("Error getting location:", error);
			}
			);
			} else {
			console.error("Geolocation is not supported by this browser.");
			}
		},
		focusMyLocation() {
			if (this.my_latitude && this.my_longitude) {
				this.center = {
				lat: this.my_latitude,
				lng: this.my_longitude,
				};
				this.$refs.gmap.panTo(this.center); // 👈 Focus map on My Location
			} else {
				this.getLocation(); // If not available, fetch again
			}
		}
		
	}
}
</script>
<style>
html{
	min-height: 100%;
}
/* body{
	background-color: '#FFF' !important;
	background-image: none !important;
} */
body{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	/* background-position: center center; */
	background-position: bottom;
   
}
.googlemap{
	height: 400px;
	border:1px solid #c6c6c6;
	border-radius: 20px;
}
.vue-map{
	border-radius: 20px;
}

.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.panel-schedule-info{
    margin-bottom: 24px;
    background: transparent linear-gradient(180deg, #FFFFFF 0%, #a5a5a5 100%) 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    backdrop-filter: blur(50px);
    padding: 12px 0px;
    text-align: center;
}
.panel-schedule-info img{
	position: relative;
	width: 25px;
	margin-top: 20px;
}
.panel-record{
	background: #fff;
    padding: 12px;
    border-radius: 20px;
	margin-top: 20px;
}
#my-table-live .thead-dark th {
    color: #fff;
	background-color: #FF9A37;
    border-color: #FF9A37;
}
#my-table-live .first-col {
   border-radius: 20px 0px 0px 0px;
   min-width: 130px;
}
#my-table-live .last-cal {
   border-radius: 0px 20px 0px 0px;
   min-width: 153px;
}
.borderRadius20{
	border-radius: 20px;
}
.table-responsive{
	border-radius: 20px;
}

.info-box img {
    display: inline-table;    
    margin: 0px;
}
.custom-select{
	border: 0px;
    background-color: #F5F5F5;
    height: 36px;
}

.custom-input{
	border: none;
    background-color: #F5F5F5;
    height: 36px !important;
}

.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #ff9f43;
    border-color: #ff9f43;
}

.page-link {
    color: #ff9f43;
   
}

.imgColorpicker{ 	
	background: #bf6917;
	border: 1px solid #c6c6c6;
	position: absolute;
	z-index: 99;
	border-radius: 14px 0px 5px 0px;
	}
	.imgColorpicker ul{
		padding: 4px;
		margin: 0px;
	}
	.imgColorpicker ul>li{
		list-style: none;
	}
.imgColorpicker img{
	width: 10px;
}
.imgColorpicker span{
	font-size: 12px;
	color:#fff
}
.font12{
	font-size: 12px;
}
.font11{
	font-size: 11px;
}
.underloadDang{
	background-color:#f7031b;
	cursor: pointer;

}
.underloadwor{
	background-color: #ffc107;
	cursor: pointer;
}
.table-container{
	position: fixed;
	z-index: 9999;
	top: 45%;
	transition: transform 2s linear;
	transform: translateY(-10%);	
}
/* .table-container.top {
    top: 34%;
} */

/* .table{
	font-size: small;
} */
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}
.loadPanel{
	position: absolute;
    width: 100%;
}

.w-20{
	width: 20%;
}

.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;
	background: #f5f5f5;
    

}

.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
	height: 36px;
	border: 0px !important;
	background: #f5f5f5 !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: 22%;;
}

.trackMe{
text-decoration:none;
}
.trackMe>div{
	border: 1px solid #ff9f43;
    padding: 5px;
    text-align: center;
    color: #5a6876;
    width: 120px;
    border-radius: 5px;
    /* margin-left: 25%; */
    margin-top: 4px;
}
.myselflocation{
	background: #a8784b;
	padding: 0px 5px 0px 2px;
}
.myselflocation img{
	width: 20px;
}




</style>